import React, { Component } from 'react';



class travelNoteShanxiShandong extends Component {

    render() {

        return ( 

            <section>
        <header>


<nav className="nav-wrapper black">
<div className="container">
    <a href="/" className="brand-logo ">
        <span>Y.X.</span>
    </a>
    
    <a href="" className="sidenav-trigger" data-target="mobile-menu">
    <i className="material-icons">menu</i>
    </a>
    <ul className="right hide-on-med-and-down">
    <li><a href="/travel">Travel</a></li>
    <li><a href="/music">Music</a></li>
    <li><a href="/calligraphy">Calligraphy</a></li>
    
    <li><a href="/cat">🐈</a></li>

    <li><a href="https://www.instagram.com/crys___7" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i>
    </a></li>
    <li><a href="https://www.youtube.com/channel/UClv5NmxBvWIjid8crocDvZQ" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-youtube"></i>
    </a></li>
    <li><a href="https://www.facebook.com/profile.php?id=100006981077508" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-facebook"></i>
    </a></li>
    <li><a href="https://twitter.com/YueqingXie" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-twitter"></i>
    </a></li>
    <li><a href="/travelNoteShanxiShandongCN" className="btn btn-floating transparent">CN</a></li>
    
    </ul>
    
    <ul className="sidenav grey lighten-2" id="mobile-menu">
        <li><a href="/travel" className="sidenavtext">Travel</a></li>
        <li><a href="/music" className="sidenavtext">Music</a></li>
        <li><a href="/calligraphy" className="sidenavtext">Calligraphy</a></li>
        <li><a href="/cat" className="sidenavtext">My Cat</a></li>
        <li><a href="/#aboutmenav" className="sidenavtext">About Me</a></li>
            <br/>
            <li><a href="/travelNoteShanxiShandongCN" className="sidenavtext">CN</a></li>

    </ul>
</div>
</nav>
</header>

           
            <div className="row hide-on-small-only" id="travelNoteShanxiShandong">
                <div className="col s2 m2 l2">
                    <div>
                        {/* <nav className="nav">
                            <a href="#video4">title 4</a>
                        </nav> */}
                        
                        <ul className="nav">
                        <div className="bigTitle">Shandong&Shanxi</div>
                            <li className="titleDate">
                                <a href="#title1">2019/06/03</a>
                            </li>
                            <li className="smallTitle">
                                <a>1.1/ Taiyuan-<a href="#title1" className="verysmallTitle">Jinci</a>/<a href="#title2" className="verysmallTitle">Cuyuan</a>/<a href="#title3" className="verysmallTitle">Yingze</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title4">2019/06/04</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.1/ Taiyuan-<a href="#title4" className="verysmallTitle">Wang</a>/<a href="#title5" className="verysmallTitle">PingYao</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title6">2019/06/05</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.1/ Taiyuan-<a href="#title6" className="verysmallTitle">Temple</a>/Datong-<a href="#title7" className="verysmallTitle">Datong</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title8">2019/06/06</a>
                            </li>
                            <li className="smallTitle">
                                <a>4.1/ Datong-<a href="#title8" className="verysmallTitle">Temple</a>/<a href="#title9" className="verysmallTitle">Heng</a>/<a href="#title10" className="verysmallTitle">Grottoes</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title11">2019/06/07</a>
                            </li>
                            <li className="smallTitle">
                                <a>5.1/ Datong-<a href="#title11" className="verysmallTitle">Wall</a>/<a href="#title12" className="verysmallTitle">Mosque</a>/<a href="#title13" className="verysmallTitle">Huayan</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title14">2019/06/08</a>
                            </li>
                            <li className="smallTitle">
                                <a>6.1/ Jinan-<a href="#title14" className="verysmallTitle">Daming</a>/<a href="#title15" className="verysmallTitle">Mountain</a>/<a href="#title16" className="verysmallTitle">Kuanhouli</a>/<a href="#title17" className="verysmallTitle">Furong</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title18">2019/06/09</a>
                            </li>
                            <li className="smallTitle">
                                <a>7.1/ Jinan-<a href="#title18" className="verysmallTitle">Springs</a>/<a href="#title19" className="verysmallTitle">Baotu</a>/Weifang-<a href="#title20" className="verysmallTitle">Kite</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title21">2019/06/10</a>
                            </li>
                            <li className="smallTitle">
                                <a>8.1/ Weifang-<a href="#title21" className="verysmallTitle">Fun</a></a>
                    
                            </li>

                            <li className="titleDate">
                                <a href="#title22">2019/06/11</a>
                            </li>
                            <li className="smallTitle">
                                <a>9.1/ Weifang-<a href="#title22" className="verysmallTitle">Market</a>/<a href="#title23" className="verysmallTitle">Kite Museum</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title24">2019/06/12</a>
                            </li>
                            <li className="smallTitle">
                                <a>10.1/ Weifang-<a href="#title24" className="verysmallTitle">Shihuyuan</a>/<a href="#title25" className="verysmallTitle">Guandi</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title26">2019/06/13</a>
                            </li>
                            <li className="smallTitle">
                                <a>11.1/ Penglai-<a href="#title26" className="verysmallTitle">Penglai</a>/<a href="#title27" className="verysmallTitle">Aquarium</a></a>
                                
                            </li>

                            <li className="titleDate">
                                <a href="#title28">2019/06/14</a>
                            </li>
                            <li className="smallTitle">
                                <a>12.1/ Changdao-<a href="#title28" className="verysmallTitle">Jiuzhangya</a>/<a href="#title29" className="verysmallTitle">Yueyawan</a>/<a href="#title30" className="verysmallTitle">Xianjingyuan</a></a>
                                
                            </li>

                            
                        </ul>
                    </div>
                </div>

                <div className="col s9 m9 l9 offset-s1 offset-m1 offset-l1 noteShanxiShandong">

                        <div className="row">
                            <div className="col s10 m10 l10 offset-s1 offset-m1 offset-l1 ">
                            <div className="row travelDetail">
                                <div className="time col s12 m4 l4">
                                    <i className=" material-icons left">access_time</i>
                                    <span>Departure</span>
                                    <span> / </span>
                                    <span>2019-06-02</span>
                                </div>
                                <div className="day col s12 m4 l4">
                                    <i className=" material-icons left">wb_sunny</i>
                                    <span>Travel Days</span>
                                    <span> / </span>
                                    <span>14 days</span>
                                </div>
                                <div className="people col s12 m4 l4">
                                    <i className=" material-icons left">account_circle</i>
                                    <span>People</span>
                                    <span> / </span>
                                    <span>With Friends</span>
                                </div>
                            </div>
                            <div className="col s1 m1 l1"></div>
                            </div>
                        </div>

                    <div className="titles" id="title1">
                        <h4 className="tooltipped title" data-tooltip="晋祠">Jinci Temple</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/1.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Jinci/@37.6987932,112.4340342,15z/data=!4m8!1m2!2m1!1z5pmL56Wg!3m4!1s0x36755217421cda9f:0x1476f8d4b4f18d30!8m2!3d37.70674!4d112.447623">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Jinci Temple</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal1">Introduction</a>
                        <div id="modal1" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Jinci Temple - Introduction</h4>
                            <p>Jinci, located in Jinci Town, Jinyuan District, Taiyuan City, Shanxi Province, was originally named Jinwangci and was originally named Tang Shuyu Temple. It was built to commemorate Tang Shuyu, the founding prince of the Jin Dynasty (later named Jin King) and his mother, Jianghou.
<br/>
<br/>
Among them, the old fountain, the statue of the maid, and the statue of the virgin are known as the "Three Wonders of Jinci". Jinci is the earliest surviving royal sacrificial garden in China, the Jin State ancestral hall; it is an intensive carrier of ancient Chinese architectural art. It is an isolated example of the main building types and epoch sequence from Song, Yuan, Ming and Qing to the Republic of China. The attached colored sculptures and murals and steles are national treasures; The comprehensive carrier of historical context, the Jin cultural system traces back to the empirical evidence of the cultural inheritance of the Western Zhou Dynasty, the feudal Tang Jian Jin to the prime Tang Zhaochuang; it is the birthplace of the Wang and Zhang clan in the world.
<br/>
<br/>
In March 1961, Jinci was announced by the State Council as the first batch of national key cultural relics protection units. In 2001, it was rated as the first batch of AAAA-level tourist attractions by the National Tourism Administration. In May 2009, it was approved as a national secondary museum by the State Administration of Cultural Heritage.</p>

                            <p className="grey-text">晋祠，位于山西省太原市晋源区晋祠镇，原名为晋王祠，初名唐叔虞祠，是为纪念晋国开国诸侯唐叔虞（后被追封为晋王）及母后邑姜后而建。
<br/>
<br/>
其中难老泉、侍女像、圣母像被誉为“晋祠三绝”。晋祠是中国现存最早的皇家祭祀园林，晋国宗祠；是中国古代建筑艺术的集约载体，国内宋元明清至民国本体建筑类型、时代序列完整的孤例，附属彩塑壁画碑碣均为国宝；是三晋历史文脉的综合载体，晋文化系统上溯西周封唐建晋至盛唐肇创文脉传承的实证；是世界王氏、张氏发祥地。 
<br/>
<br/>
1961年3月，晋祠被国务院公布为第一批全国重点文物保护单位。2001年，被国家旅游局评为首批AAAA级旅游景区。2009年5月，被国家文物局批准为国家二级博物馆。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%99%8B%E7%A5%A0/128888?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/03</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/1.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Arrived in Taiyuan on the evening of the 2nd and stayed at the Orange Hotel on South Inner Ring Street.

</p>
                                    <p>On the morning of the 3rd, have breakfast nearby.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/2.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Take a taxi to Jinci</p>
                                    <p>

There are many tour guides at the gate of Jinci, you can ask one to explain if you need it.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/3.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>NanLao Spring</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title2">
                        <h4 className="tooltipped title" data-tooltip="东湖醋园">Donghucu Sales Department</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/2.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Donghucu+Sales+Department/@37.8795888,112.5945617,17z/data=!3m1!4b1!4m5!3m4!1s0x360aa83862ac1b07:0xcdfde1cd3fe8c178!8m2!3d37.8795846!4d112.5967504">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Donghucu Sales Department</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal2">Introduction</a>
                        <div id="modal2" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Donghucu Sales Department - Introduction</h4>
                            <p>The exhibition hall and vinegar therapy garden of Donghu Vinegar Garden. Collected various vinegar brewing utensils, farming utensils and more than 700 vinegar therapy prescriptions since the Western Han Dynasty of our country. The historical and cultural heritage of Shanxi old vinegar is fully displayed in the form of ancient and modern utensils, excerpts from literature, pictures, photos, and physical products. . Near the antique building Meihe Ju Vinegar Workshop, oncoming is the sour and fragrant old vinegar smell.
                            <br/>
<br/>
Entering the quaint Meiheju vinegar workshop is like coming to an old vinegar workshop 500 years ago. The old vinegar is fragrant, tangy, and full of vinegar, which is unforgettable. The craftsmanship and steps of "steaming, fermenting, fumigating, drenching and drying" old aged vinegar are at a glance in the workshop. Visitors can participate in part of the production process or enjoy the "sweet, sour, fragrant, sweet and fresh" feeling of old aged vinegar. respectable.
                            
                            
</p>

                            <p className="grey-text">东湖醋园的陈列堂和醋疗园。分别收集了我国西汉以来各种酿醋器具、农耕器具和700余个醋疗药方，以古今器皿展示、文献典籍摘记，图片照片写真，产品实物陈列等形式充分展示了山西老陈醋的历史文化底蕴。临近仿古建筑美和居醋坊，迎面而来的是既酸又香的老陈醋气味。
<br/>
<br/>
进入古色古香的美和居醋坊，犹如来到了500年前的老陈醋作坊，老醋芳香、扑鼻沁心，醋味十足，难以忘怀。作坊内“蒸、酵、熏、淋、晒”的老陈醋制作工艺和步骤一览无余，游客参与部分制作过程或者尽兴品尝老陈醋“绵、酸、香、甜、鲜”之感的姿态可亲可敬。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E4%B8%9C%E6%B9%96%E9%86%8B%E5%9B%AD/9584213?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/03</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/4.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Take a taxi to the Donghucu Sales Department.</p>
                                    <p>

Here you can see the vinegar brewing process and taste the vinegar of different years.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/5.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Have lunch at Maoye Tiandi at noon.</p>
                                </div>
                            </div>


                            




                        </div>
                        
                    </div>

                    <div className="titles" id="title3">
                        <h4 className="tooltipped title" data-tooltip="迎泽公园">Yingze Park</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/3.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Yingze+Park/@37.8550382,112.5600673,17z/data=!3m1!4b1!4m5!3m4!1s0x360aa90e6f9adefb:0x5dccc24927d6fc4!8m2!3d37.855034!4d112.562256">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Yingze Park</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal3">Introduction</a>
                        <div id="modal3" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Yingze Park - Introduction</h4>
                            <p>Yingze Park is the largest park in Taiyuan, named after it is located outside the Yingze Gate of the ancient Taiyuan City. The total area of Yingze Park is 666,900 square meters, and the water surface of Yingze Lake occupies one third of the total area. It mainly includes popular science areas, scenic spots and amusement areas. Yingze Park was officially opened in June 1957.
                            </p>

                            <p className="grey-text">迎泽公园是太原市内最大的公园，因位于古太原城迎泽门外而得名。迎泽公园总面积666900平方米，迎泽湖水面占总面积的三分之一，主要有科普区、风景区以及游乐区域。迎泽公园于1957年6月正式开放。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%BF%8E%E6%B3%BD%E5%85%AC%E5%9B%AD/3170614?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/03</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/6.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Yingze Park</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/7.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Eat Taiyuan cuisine at the old Taiyuan restaurant for dinner.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/8.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Take a walk in Taiyuan (Fenhe) at night.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/9.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Get a massage before going back to the hotel.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title4">
                        <h4 className="tooltipped title" data-tooltip="王家大院">Wang Family Courtyard</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/4.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E7%8E%8B%E5%AE%B6%E5%A4%A7%E9%99%A2/@36.896145,111.3142943,9z/data=!4m8!1m2!2m1!1z546L5a625aSn6Zmi!3m4!1s0x3675cab952f23bdd:0xa8da9991f30f827f!8m2!3d36.896145!4d111.874597">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Wang Family Courtyard</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal4">Introduction</a>
                        <div id="modal4" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Wang Family Courtyard - Introduction</h4>
                            <p>The Wang Family Courtyard is located in Jingsheng Town, a famous Chinese historical and cultural town 12 kilometers east of Lingshi County, Shanxi Province. It is 35 kilometers away from the world cultural heritage Pingyao Ancient City and 4 kilometers away from Jiexiu Mianshan Mountain.
                            <br/>
<br/>
The Wang Family Courtyard was built by the Jingsheng Wang family through the Ming and Qing dynasties for more than 300 years. It includes five lanes and six castles and a street with a total area of 250,000 square meters. It is an architectural art museum with traditional cultural characteristics. . It is a national key cultural relics protection unit and a 4A-level scenic spot.</p>

                            <p className="grey-text">王家大院位于山西省灵石县城东12公里处的中国历史文化名镇静升镇。距世界文化遗产平遥古城35公里、介休绵山4公里。
<br/>
<br/>
王家大院是由静升王氏家族经明清两朝、历300余年修建而成，包括五巷六堡一条街，总面积达25万平方米，而且是一座具有传统文化特色的建筑艺术博物馆。它是全国重点文物保护单位和4A级景区。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E7%8E%8B%E5%AE%B6%E5%A4%A7%E9%99%A2/196361?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/04</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/10.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Order a breakfast takeaway at the hotel.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/11.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Contracted a car.</p>
                                    <p>Arrive at the Wang Family Courtyard first.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/12.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Wang Family Courtyard</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/13.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>A big monkey in the front is gnawing a birthday peach, and a little monkey is behind him. It’s worth noting that the hands of the two monkeys were naughty covering their ears, which meant that they were telling the descendants of the Wang family to "keep their ears off the window and read only the sage books", and they were also telling their tribesmen whether to manage the house or govern the country. It should be done "Do not listen to evil."</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/14.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p></p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/15.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p></p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title5">
                        <h4 className="tooltipped title" data-tooltip="平遥古城">The AncientCity of Ping Yao</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/5.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Pingyao,+Jinzhong,+Shanxi,+China/@37.1396179,111.9656037,10z/data=!3m1!4b1!4m5!3m4!1s0x36750a69fc81187f:0xeaf4b4528d55f07e!8m2!3d37.189822!4d112.176206">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">The AncientCity of Ping Yao</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal5">Introduction</a>
                        <div id="modal5" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">The AncientCity of Ping Yao - Introduction</h4>
                            <p>The ancient city of Pingyao is located in the central part of Shanxi Province. It was built in the reign of King Zhou Xuan and expanded in the third year of Hongwu in the Ming Dynasty (1370). It has a history of more than 2,700 years. It still retains the basic features of the county in the Ming and Qing Dynasties. It is the most complete ancient city in the Han ethnic region in China.
                            <br/>
<br/>
Pingyao, Shanxi is known as one of the "four best-preserved ancient cities", and it is also one of the only two ancient cities in China that has successfully declared its entire ancient city as a world cultural heritage.
<br/>
<br/>
The World Heritage Center describes: Pingyao Ancient City is an outstanding example of ancient Chinese cities in the Ming and Qing Dynasties, and Pingyao Ancient City has preserved all its characteristics. Moreover, in the development of Chinese history, it showed people a complete picture of extraordinary cultural, social, economic and religious development.</p>

                            <p className="grey-text">平遥古城位于山西省中部，始建于周宣王时期，明洪武三年（1370年）扩建，距今已有2700多年的历史。还较为完好地保留着明清时期县城的基本风貌，是中国汉民族地区现存最为完整的古城。 
<br/>
<br/>
山西平遥被称为“保存最为完好的四大古城”之一，也是中国仅有的以整座古城申报世界文化遗产获得成功的两座古城市之一。 
<br/>
<br/>
世界遗产中心描述称：平遥古城是中国古代城市在明清时期的杰出范例，平遥古城保存了其所有特征。而且，在中国历史的发展中，为人们展示了一幅非同寻常的文化、社会、经济及宗教发展的完整画卷。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%B9%B3%E9%81%A5%E5%8F%A4%E5%9F%8E/791?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/04</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/16.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Ancient City Wall</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/17.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>There are many types of pasta in Shanxi.</p>
                                    <p>

Dinner was in the Shanxi Guild Hall, and the running man also recorded in this Shanxi Guild Hall.</p>
                                </div>
                            </div>


                        </div>
                        
                    </div>

                    <div className="titles" id="title6">
                        <h4 className="tooltipped title" data-tooltip="双塔寺">Twin Pagoda Temple</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/6.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Twin+Pagoda+Temple/@37.8452152,112.5975463,17z/data=!3m1!4b1!4m5!3m4!1s0x360aa9ea66014027:0x758e6f347c24b92a!8m2!3d37.845211!4d112.599735">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Twin Pagoda Temple</span>
                                </a>

                                
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal6">Introduction</a>
                        <div id="modal6" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Twin Pagoda Temple - Introduction</h4>
                            <p>The Twin Towers of Yongzuo Temple, also known as Lingxiao Twin Towers, are the tallest existing ancient buildings in Taiyuan, the capital of Shanxi. Located at the foot of the mountain in the southeast of Taiyuan City. The two towers in Yongzuo Temple are like a pair of twin sisters. The Lingxiao Twin Towers also have a beautiful nickname-the two peaks of writing and writing.
                            <br/><br/>
These two sister towers are twin towers, one is the "WenFeng Pagoda" built first, and the other is the "SheLi Pagoda" built later. The towering twin towers are the tallest in my country.
                            
                            </p>

                            <p className="grey-text">永祚寺双塔，又名凌霄双塔，是山西省会太原现存古建筑中最高的建筑。位于太原市城区东南向山脚畔。永祚寺内的两塔犹如一对孪生姊妹，相映成趣。凌霄双塔还有一个美丽动听的别称—文笔双峰。 
                            <br/><br/>
这两座形同孪生的姊妹塔，一个是先建的“文峰塔”，一个是后建的“舍利塔”。双塔巍峨俊秀，是我国双塔之最。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%B0%B8%E7%A5%9A%E5%AF%BA%E5%8F%8C%E5%A1%94/10421244?fromtitle=%E5%8F%8C%E5%A1%94%E5%AF%BA&fromid=16814&fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/05</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/18.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Ascending to the top, the tower is really narrow and steep.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title7">
                        <h4 className="tooltipped title" data-tooltip="大同古城">Datong Ancient City</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/7.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E5%A4%A7%E5%90%8C%E5%9F%8E%E5%A2%99/@40.08546,113.2454043,12z/data=!4m8!1m2!2m1!1z5aSn5ZCM5Y-k5Z-O!3m4!1s0x35e2d45c674b730b:0x78a9bb6882503e14!8m2!3d40.0853498!4d113.3154445">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Datong Ancient City</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal7">Introduction</a>
                        <div id="modal7" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Datong Ancient City - Introduction</h4>
                            <p>The ancient city wall of Datong was built on the old soil city of Yuangu city wall in the fifth year of Hongwu in Ming Dynasty (1372), and it is quite famous throughout the country. The total perimeter of the city wall of Datong is 7270.7 meters, forming a square city.
                            </p>

                            <p className="grey-text">大同古城墙为明洪武五年(1372年)在元故城墙旧土城上增筑而成，全国颇有名气。大同城墙的总周长为7270．7米，形制方形城池。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%A4%A7%E5%90%8C%E5%8F%A4%E5%9F%8E%E5%A2%99/2445538?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                        <div className="titleContent">
                            <h5>2019/06/05</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/19.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Dongfang noodles</p>
                                </div>
                            </div>



                        </div>
                  
                        
                    </div>

                    <div className="titles" id="title8">
                        <h4 className="tooltipped title" data-tooltip="悬空寺">Hanging Temple</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/8.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E6%82%AC%E7%A9%BA%E5%AF%BA/@39.658174,113.6948065,14z/data=!4m8!1m2!2m1!1z5oKs56m65a-6!3m4!1s0x35e3143512ab84c3:0x7ef5f694a4d2797f!8m2!3d39.658174!4d113.712316">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Hanging Temple</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal8">Introduction</a>
                        <div id="modal8" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Hanging Temple - Introduction</h4>
                            <p>Xuankong Temple(Hanging Temple), located between the cliffs of Cuiping Peak on the west side of Jinlong Gorge of Hengshan Mountain, Hunyuan County, Datong City, Shanxi Province, was originally called "Xuankong Pavilion". "Xuan" is derived from Chinese Taoist teachings, and "empty" is derived from Buddhist teachings. It was later renamed "Xuankong Temple" because the whole temple seemed to hang on a cliff. In Chinese, "Xuan" and "Xuan" are homophones, hence the name. Built in 491 AD, it is a unique temple that combines Buddhism, Taoism and Confucianism. The "Hanging Temple" architecture is very distinctive. It is famous for its steepness as facing the abyss. It is known as the slang term "hanging Temple, half-day high, with three horsetails hanging in the sky". It is famous for its steepness as facing the abyss.
                            <br/><br/>
The Hanging Temple is a key cultural relics protection unit in Shanxi Province, and is the "first scenic spot" among the 18 scenic spots in Hengshan. In 2010, he was selected as one of the ten most dangerous buildings in the world by Time Magazine.</p>

                            <p className="grey-text">悬空寺，位于山西省大同市浑源县恒山金龙峡西侧翠屏峰峭壁间，原叫“玄空阁”，“玄”取自于中国道教教理，“空”则来源于佛教的教理，后改名为“悬空寺”，是因为整座寺院就像悬挂在悬崖上，在汉语中，“悬”与“玄”同音，因此得名。建成于公元491年，是佛、道、儒三教合一的独特寺庙。“悬空寺”建筑极具特色，以如临深渊的险峻而著称，素有“悬空寺，半天高，三根马尾空中吊”的俚语，以如临深渊的险峻而著称。
<br/><br/>
悬空寺是山西省重点文物保护单位，恒山十八景中“第一胜景”。2010年入选《时代周刊》世界岌岌可危十大建筑。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%82%AC%E7%A9%BA%E5%AF%BA/1132?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/06</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/20.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>The wisdom of the ancients</p>
                                    <p>I signed up for a one-day-trip today.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title9">
                        <h4 className="tooltipped title" data-tooltip="恒山">Mount Heng</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/9.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Mount+Heng/@39.6728066,113.7240542,15z/data=!3m1!4b1!4m5!3m4!1s0x35e314eca54c24bd:0x728a6ddd443e0192!8m2!3d39.672791!4d113.732809">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Mount Heng</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal9">Introduction</a>
                        <div id="modal9" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Mount Heng - Introduction</h4>
                            <p>Hengshan has two concepts in a narrow sense and a broad sense. In the narrow sense, Hengshan is the so-called "Beiyue Hengshan", also known as "Taiheng Mountain". It was called Xuanwu Mountain and Nao Mountain in ancient times. It is high mountain and Xuanyue. It was identified as the "Five Sacred Mountains" in the late Ming and early Qing Dynasty. Located 10 kilometers south of Hunyuan County, Shanxi Province, the main peak Tianfengling is 2016.8 meters above sea level. It is known as "Rentian North Pillar" and "Unbelievably Famous Mountain". In a broad sense, Hengshan Mountain, or Hengshan Mountain Range, is the general term for a series of peaks between the Sanggan River and Hutuo River in the southeast of Datong City, Shanxi Province and the south of Zhangjiakou City, Hebei Province. It is about 80 kilometers wide from north to south. The highest peak is Mantou Mountain at the border of Daixian and Yingxian, with an altitude of 2,426 meters.
                            <br/><br/>
Hengshan Mountain lies between the plateau in the northwest of the mountain and the Jizhong Plain. Because of its steep natural mountains and geographical location, it has become a battleground for military experts. In the valleys between mountains, Daomaguan, Zijingguan, Pingxingguan, Yanmenguan, Ningwuguan are dangerous, and they are the key throats of the plateau beyond the Great Wall to the Taiyuan Basin and the Jizhong Plain. Many emperors and famous generals have fought here, and many ancient battlefields such as ancient passes, castles, and beacon towers have been preserved.
<br/><br/>
Since the Ming Dynasty, it was listed as Beiyue. In the early Qing Dynasty, the national sacrifice of Beiyue gradually moved from Quyang, Hebei to Hunyuan Hengshan, and the Wuyue culture was integrated into the Hengshan culture. Hengshan Taoism began in the Western Han Dynasty and flourished in the Northern Wei Dynasty, becoming the holy place of the mainstream Quanzhen School.
<br/><br/>
The Hengshan Mountains are also rich in mineral resources in Shanxi Province, and are the main producing areas of coal and iron in the northeast of Shanxi Province.</p>

                            <p className="grey-text">恒山，含狭义和广义两个概念。狭义的恒山，即所谓“北岳恒山”，亦名“太恒山”，古称玄武山、崞山，高是山，玄岳等，明末清初被确定为“五岳”之北岳恒山。位于山西省浑源县城南10公里处，主峰天峰岭海拔2016.8米，号称“人天北柱”、“绝塞名山”。广义的恒山，或称恒山山脉，是山西省大同市东南部、河北省张家口市南部，桑干河、滹沱河之间一系列山峰的总称，大致西南－东北走向延伸，东西长近300公里左右，南北宽80公里左右，最高峰为代县、应县边界处的馒头山，海拔2426米。
<br/><br/>
恒山横亘于山西北部高原与冀中平原之间，因其险峻的自然山势和地理位置的特点，成为兵家必争之地。山间河谷处的倒马关、紫荆关、平型关、雁门关、宁武关虎踞为险，是塞外高原通向太原盆地、冀中平原之咽喉要冲。许多帝王、名将都在此打过仗，古代关隘、城堡、烽火台等众多古代战场遗迹保存了下来。
<br/><br/>
自明代，被列为北岳，清初，北岳国家祭祀也逐渐由河北曲阳移至浑源恒山，五岳文化融入恒山文化中。恒山道教始于西汉，北魏始兴盛，成为主流全真派圣地。
<br/><br/>
恒山山脉也是山西省矿产资源的富集区，是山西省东北部煤、铁等的主产区。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%81%92%E5%B1%B1/395558?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/06</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/21.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Take the cable car to the top of Mount Heng.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title10">
                        <h4 className="tooltipped title" data-tooltip="云冈石窟">Yungang Grottoes</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/10.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Yungang+Grottoes/@40.1115138,113.1302848,17z/data=!3m1!4b1!4m5!3m4!1s0x35e2cc48520de2e3:0xff93e49966b42707!8m2!3d40.1115097!4d113.1324735">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Yungang Grottoes</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal10">Introduction</a>
                        <div id="modal10" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Yungang Grottoes - Introduction</h4>
                            <p>The Yungang Grottoes are located at the southern foot of the Wuzhou (Zhou) Mountain and the north bank of the Wuzhou River, about 16 kilometers west of Datong City, Shanxi Province. There are 45 main caves, 252 large and small niches, and more than 51,000 stone statues. It is one of the largest ancient grottoes in China.
                            <br/><br/>
Yungang Grottoes was announced by the State Council as one of the first national key cultural relics protection units in 1961. It was included in the UNESCO World Heritage List on December 14, 2001, and was named the first batch of countries by the National Tourism Administration on May 8, 2007. 5A-level tourist attractions.</p>

                            <p className="grey-text">云冈石窟位于山西省大同市城西约16公里的武州（周）山南麓、武州川的北岸，石窟依山开凿，东西绵延约1公里。存有主要洞窟45个，大小窟龛252个，石雕造像51000余躯，为中国规模最大的古代石窟群之一。 
<br/><br/>
云冈石窟在1961年被国务院公布为全国首批重点文物保护单位，2001年12月14日被联合国教科文组织列入世界遗产名录，2007年5月8日被国家旅游局评为首批国家5A级旅游景区。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E4%BA%91%E5%86%88%E7%9F%B3%E7%AA%9F/1252?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/06</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/22.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Wei Bei.</p>
                                    <p>

This is a font that many people do not appreciate.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/23.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Yungang Grottoes-Yungang Giant Buddha</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/24.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Wangfu Zhizunkou Fuju Hot Pot</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title11">
                        <h4 className="tooltipped title" data-tooltip="九龙壁">Nine Dragon Wall</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/11.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Nine+Dragon+Screen+Ticket+Office/@40.0932401,113.3013573,17z/data=!3m1!4b1!4m5!3m4!1s0x35e2d46238938695:0xce576781633c39aa!8m2!3d40.093236!4d113.303546">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Nine Dragon Wall</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal11">Introduction</a>
                        <div id="modal11" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Nine Dragon Wall - Introduction</h4>
                            <p>The Nine Dragon Wall of Datong, located in Heyang Street, Pingcheng District, Datong City, Shanxi Province, was built in the 25th year of Hongwu in the Ming Dynasty (1392). It is the front wall of the residence of the thirteenth son of Emperor Zhu Yuanzhang of Ming Dynasty. It has a history of more than 600 years. The wall is 8 meters high, 2.02 meters thick, and 45.5 meters long. There are 9 flying dragons evenly distributed on the wall. There are sun and moon patterns on both sides. The ceiling of the hall-style wall is decorated with embossed lotus flowers and swimming dragons on the ridge. The four corners of the ridge are placed with animals. The wall is made of 426 special multicolored glazed components. The 9 flying dragons are magnificent, and the momentum of flying jumps on the wall.
                            <br/>
<br/>
On the Nine Dragon Wall of Datong, the gaps between the dragons are filled with patterns of mountains, rocks and water plants, reflecting and contrasting each other. The wall is covered with glazed tiles, and the top is supported by glazed bucket arches. The bottom of the wall is the Xumizuo, 2.09 meters high, stocky and rich, with 41 sets of two dragons and beads carved on it. The waist is made up of 75 glazed bricks in relief, with cows, horses, sheep, dogs, deer, rabbits and other animal images, which are lively and colorful.</p>

                            <p className="grey-text">大同九龙壁，位于山西省大同市平城区和阳街，建于明代洪武二十五年(1392年)，是明太祖朱元璋第十三子朱桂代王府邸前照壁，距今已有600多年的历史。壁高8米，厚2.02米，长45.5米。壁上均匀协调地分布着9条飞龙。两侧为日月图案。庑殿式壁顶，正脊饰凸雕莲花及游龙，四角戗脊置走兽，壁面由426块特制五彩琉璃构件拼砌而成。9条飞龙气势磅礴，飞腾之势跃然壁上。
<br/>
<br/>
大同九龙壁，龙的间隙由山石、水草图案填充，互相映照、烘托。壁顶覆盖琉璃瓦，顶下由琉璃斗拱支撑。壁底为须弥座，高2.09米，敦实富丽，上雕41组二龙戏珠图案。腰部由75块琉璃砖组成浮雕，有牛、马、羊、狗、鹿、兔等多种动物形象，生动活泼，多彩多姿。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%A4%A7%E5%90%8C%E4%B9%9D%E9%BE%99%E5%A3%81/765525?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/07</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/25.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Nine Dragon Wall</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title12">
                        <h4 className="tooltipped title" data-tooltip="清真大寺">Great Mosque</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/12.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E6%B8%85%E7%9C%9F%E5%A4%A7%E5%AF%BA/@40.0926991,113.2988063,17z/data=!3m1!4b1!4m5!3m4!1s0x35e2d4631c50a565:0xaa74879e5a471ea3!8m2!3d40.092695!4d113.300995">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Great Mosque</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal12">Introduction</a>
                        <div id="modal12" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Great Mosque - Introduction</h4>
                            <p>The Great Mosque of Datong is one of two well-known ancient mosques in Shanxi. Located in the Ninth Floor Alley, Daxi Street, Datong City, the temple was rebuilt in the 7th year of Emperor Qianlong (1742). "The Monument of the Mosque Built by the Order" is said to have been built in the 2nd year of Tang Zhenguan (628). It has a history of more than 1,200 years. .
                            <br/><br/>
It is six hundred and seventy years earlier than the center of worship, gatherings and festivals for Muslims in Beijing and the Dongsi Mosque (also known as Faming Temple) where the Islamic Association of China is located.</p>

                            <p className="grey-text">大同清真大寺为山西境内两座知名清真古寺之一。位于大同城内大西街九楼巷，寺内乾隆七年(1742年)重立《敕建清真寺碑》称始建于唐贞观二年(628年)，至今已有一千二百多年的历史。
<br/><br/>
它比北京穆斯林进行礼拜、聚礼和节日活动的中心，中国伊斯兰教协会所在地东四清真寺（又名法明寺）要早六百七十年，或为伪托。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%A4%A7%E5%90%8C%E6%B8%85%E7%9C%9F%E5%A4%A7%E5%AF%BA/8565328?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/07</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/26.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Great Mosque</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title13">
                        <h4 className="tooltipped title" data-tooltip="华严寺">Huayan Temple</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/13.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Huayan+Temple/@40.0905141,113.3125383,17z/data=!3m1!4b1!4m5!3m4!1s0x35e2d45f1ae0f0a1:0xf6817c1718ad8a84!8m2!3d40.09051!4d113.314727">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Huayan Temple</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal13">Introduction</a>
                        <div id="modal13" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Huayan Temple - Introduction</h4>
                            <p>Huayan Temple, located in the southwest corner of the ancient city of Datong, was built in the seventh year of Liao Zhongxi (1038 AD) and named after the Buddhist classic "Hua Yan Jing". It also has the nature of the royal ancestral temple of the Liao Kingdom, and its status is prominent. After being destroyed by war, Jin Tianjuan was rebuilt for three years (1140). Huayan Temple sits from west to east. More than 30 single buildings, such as the mountain gate, Puguangming Hall, Daxiong Hall, Bojia Temple, and Huayan Pagoda, are arranged on the two main axes of the north and the south, and the layout is strict.
                            <br/>
                            <br/>
Huayan Temple, covering an area of 66,000 square meters, is an older and well-preserved Liaojin temple complex in China. It was announced by the State Council in 1961 as the first batch of national key cultural relics protection units. It was approved as a national AAAA-level tourist attraction in 2014.</p>

                            <p className="grey-text">华严寺，位于大同古城内西南隅，始建于辽重熙七年（公元1038年），依据佛教经典《华严经》而命名。兼具辽国皇室宗庙性质，地位显赫。后毁于战争，金天眷三年（1140年）重建。华严寺坐西向东，山门、普光明殿、大雄宝殿、薄伽教藏殿、华严宝塔等30余座单体建筑分别排列在南北两条主轴线上，布局严谨。
                            <br/>
                            <br/>
华严寺，占地面积达66000平方米，是中国现存年代较早、保存较完整的一座辽金寺庙建筑群，1961年被国务院公布为第一批全国重点文物保护单位。2014年被批准为国家AAAA级旅游景区。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%8D%8E%E4%B8%A5%E5%AF%BA/2285867?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>      
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/07</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/27.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Huayan Temple</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/28.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Xijin Road Noodle House</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title14">
                        <h4 className="tooltipped title" data-tooltip="大明湖">Daming Lake</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/14.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Daming+Lake/@36.6748993,117.0207281,16z/data=!3m1!4b1!4m5!3m4!1s0x35c205d6bfafd47f:0xe9a6983479e96d10!8m2!3d36.6756694!4d117.0257093">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Daming Lake</span>
                                </a>

                                
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal14">Introduction</a>
                        <div id="modal14" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Daming Lake - Introduction</h4>
                            <p> Daming Lake (Daming Lake) Jinan city lake in Shandong Province, one of the three historical places in Jinan. Located in the northern part of the old town of Lixia District, Jinan City, Shandong Province, it is formed by the confluence of many springs in Jinan. The lake water flows into Xiaoqing River through Luoshui River. The lake covers an area of 46 hectares with an average water depth of 2 to 3 meters. Daming Lake has beautiful scenery and clear blue water. It is one of the core components of the national 5A-level tourist attraction-the world's first spring scenic area.
                            <br/><br/>
Daming Lake has a long history. There are many buildings and natural landscapes that commemorate the achievements and whereabouts of ancients, such as Lixia Pavilion, Tiegong Temple, Xiaocanglang, Arctic Pavilion, Huibo Tower, Nanfeng Temple, Xiayuan Temple, Jiaxuan Temple, etc. Literati of the past dynasties came to mourn and chant. The poets of the past dynasties after the Tang Dynasty have left famous poems.
<br/><br/>
After the liberation, the park was officially opened in 1957, and after several repairs and beautifications, it has become one of the famous tourist attractions in Jinan.</p>

                            <p className="grey-text">大明湖（Daming Lake）山东省济南市区湖泊、济南三大历史名胜之一。位于山东省济南市历下区旧城区北部，是由济南众多泉水汇流而成，湖水经泺水河注入小清河。湖水面积46公顷，水深平均2~3米。大明湖景色优美秀丽，湖水水色澄碧，是国家5A级旅游景区——天下第一泉风景区的核心组成部分之一。 
                            <br/><br/>
大明湖历史悠久，纪念古人政绩、行踪的建筑以及自然景观很多，诸如历下亭、铁公祠、小沧浪、北极阁、汇波楼、南丰祠、遐园、稼轩祠等，引得历代文人前来凭吊、吟咏。唐代以后的历代诗人，都留下了著名的诗篇。
<br/><br/>
解放后，于1957年正式辟建成公园，几经修缮美化，成为济南市著名的游览胜地之一。
                            
                           </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%A4%A7%E6%98%8E%E6%B9%96/132623?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>   
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/08</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/29.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Flew to Jinan in the afternoon on the 7th and stayed at the Orange Hotel in Quancheng Square.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/30.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>In the morning, have breakfast at Chao Shisan Chaoshan casserole by Daming Lake.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/31.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Chaoran building</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/32.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Daming Lake</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title15">
                        <h4 className="tooltipped title" data-tooltip="千佛山">Thousand Buddha Mountain</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/15.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Thousand+Buddha+Mountain/@36.6366694,117.0272882,15z/data=!3m1!4b1!4m5!3m4!1s0x35c204558f64e2b7:0xb566fa9d14adff92!8m2!3d36.636653!4d117.036043">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Thousand Buddha Mountain</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal15">Introduction</a>
                        <div id="modal15" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Thousand Buddha Mountain - Introduction</h4>
                            <p>Thousand Buddha Mountain is located in Lixia District, Jinan City, Shandong Province. It is one of the three major scenic spots in Jinan. During the reign of Emperor Kaihuang of Sui Dynasty (581-600), because of the prevalence of Buddhism, thousands of Buddha statues were carved along the mountain, so it was called Qianfo Mountain.
                            <br/>
<br/>
Thousand Buddha Mountain is the remnant of Mount Tai. It is 285 meters above sea level and covers an area of 166.1 hectares. It is 2.5 kilometers away from Jinan city center. It is located in the south of Jinan city center in Shandong Province. It is also known as the three major scenic spots in Jinan along with Baotu Spring and Daming Lake. It is a national AAAA level. Tourist attractions are the ninth batch of national-level scenic spots.</p>

                            <p className="grey-text">千佛山位于山东省济南市历下区，是济南三大名胜之一，古称历山，因为古史称舜在历山耕田的缘故，又曾名舜山和舜耕山。隋开皇年间（581年一600年），因佛教盛行，随山势雕刻了数千佛像，故称千佛山。
                            <br/>
<br/>
千佛山是泰山的余脉，海拔285米，占地166.1公顷，距济南市中心2.5公里，位于山东省济南市中心南部，与趵突泉、大明湖并称济南三大名胜，是国家AAAA级旅游景区，是第九批国家级风景名胜区。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%8D%83%E4%BD%9B%E5%B1%B1/3838147?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                        <div className="titleContent">
                            <h5>2019/06/08</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/33.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Go to top of Thousand Buddha Mountain by cable car.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/34.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>The slide in Thousand Buddha Mountain, if you go up, your neck will be tired, but going down is fun.</p>
                                </div>
                            </div>

                        


                        </div>
                        
                    </div>

                    <div className="titles" id="title16">
                        <h4 className="tooltipped title" data-tooltip="宽厚里">Shimao Kuanhouli Jinan</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/16.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E5%AE%BD%E5%8E%9A%E6%89%80%E8%A1%97/@36.661105,116.9726595,17z/data=!3m1!4b1!4m5!3m4!1s0x35c20f7ab5155555:0x83665bfed76931f1!8m2!3d36.6611007!4d116.9748482">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Shimao Kuanhouli Jinan</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal16">Introduction</a>
                        <div id="modal16" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Shimao Kuanhouli Jinan - Introduction</h4>
                            <p>Kuanhouli (Shimao Kuanhouli Jinan), also known as Jinan Kuanhouli and Shimao Kuanhouli, is located in the core area of Quancheng Road in Jinan City. Kuanhousuo Street in old Jinan is Shimao Kuanhouli Jinan's traditional vocabulary for the continuation of old Jinan architecture and folklore. Create a century-old historic district in Qilu, where the Mao and the street are in dialogue, the river and the city are shared, the river and the city are echoed, the spring and water are integrated, and the history and modernity blend together.</p>

                            <p className="grey-text">宽厚里（Shimao Kuanhouli Jinan），又称济南宽厚里、世茂宽厚里，位于济南市泉城路核心地段，老济南的宽厚所街，是世茂股份为延续老济南建筑、民俗的传统语汇，于城市中心打造茂与街对话、河与市共享，河与城呼应、泉与水融合、历史与现代交融的齐鲁大地百年历史街区。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%AE%BD%E5%8E%9A%E9%87%8C/22099702?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/08</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/35.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>In the afternoon, We came to Kuanhouli for a snack, and then returned to the hotel to blow on the air-conditioning because it was too hot.</p>
                                </div>
                            </div>

                        
                        </div>
                        
                    </div>

                    <div className="titles" id="title17">
                        <h4 className="tooltipped title" data-tooltip="芙蓉街">FuRong Street</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/17.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Fu+Rong+Jie,+Quan+Cheng+Lu+Shang+Quan,+Lixia+Qu,+Jinan+Shi,+Shandong+Sheng,+China/@36.666961,117.0208381,17z/data=!3m1!4b1!4m5!3m4!1s0x35c205cfc63c36fb:0x544c4266ddd36c02!8m2!3d36.6669567!4d117.0230268">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">FuRong Street</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal17">Introduction</a>
                        <div id="modal17" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">FuRong Street - Introduction</h4>
                            <p>Furong Street Furong Street is located in Lixia District, Jinan City, Shandong Province. It is an old street and snack street with characteristics of Jinan in the spring city. Furong Street is a north-south pedestrian street, named for the famous spring on the street-Furong Spring.
                            <br/><br/>
Furong Street starts at the south entrance of Donghuaqiangzi Street in the north, and ends at Quancheng Road in the south. It is adjacent to Mashi Street to the east, leading to Fengqiao Street, Xiangfeng Alley and Furong Alley, to the west to Yuhuanquan Street, and to the East Street of Provincial Government. The bluestone pavement is 432 meters long and 4.6 meters wide.</p>

                            <p className="grey-text">芙蓉街 Furong Street 位于山东省济南市历下区，是一条泉城济南特色的老街以及小吃街。芙蓉街是一条南北走向的步行街，因街上有名泉——芙蓉泉而得名。
<br/><br/>
芙蓉街北起东花墙子街南口，南至泉城路。东邻马市街，通起凤桥街、翔凤巷和芙蓉巷，西邻玉环泉街，通省府东街。青石板路面，全长432米，宽4.6米。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%8A%99%E8%93%89%E8%A1%97/1832751?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/08</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/36.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>At night, the fountain in Quancheng Square.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/37.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Came to Furong Street to continue eating.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title18">
                        <h4 className="tooltipped title" data-tooltip="黑虎泉">Black Tiger Springs</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/18.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E9%BB%91%E8%99%8E%E6%B3%89/@36.6624513,117.0311013,17z/data=!3m1!4b1!4m5!3m4!1s0x35c205cca8e0ac0f:0xbcdcc0e1fae69c28!8m2!3d36.662447!4d117.03329">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Black Tiger Springs</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal18">Introduction</a>
                        <div id="modal18" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Black Tiger Springs - Introduction</h4>
                            <p>Black Tiger Springs (Black Tiger Springs) is located on the south bank of the moat of Jiefangge South, Lixia District, Jinan City, Shandong Province, on the Heihuquan East Road, Jinan City.
                            <br/><br/>
Heihu Spring is a natural cave with a height of 2 meters, a depth of 3 meters and a width of 1.7 meters. The spring water mainly comes from the southeast of the cave. The cave is built of bluestone, and the cave is hidden under the rock wall. The spring pool is made of stones and is slightly rectangular, about 17 meters wide and 3 meters deep. Three stone tiger heads are juxtaposed on the south wall of the spring pond. The spring water flows through the dark ditch and spews out through 3 stone tiger mouths. The maximum daily water inflow is 41,000 cubic meters, second only to Baotu Spring. There are 14 famous springs such as Pipa, Xizhong and Jiu Nu nearby, forming the Black Tiger Spring Group.
<br/><br/>
Heihuquan is one of Jinan’s "72 Famous Springs" recorded in the "Famous Spring Stele" of the Jin Dynasty, the "Seven-Two Spring Poems" of Yan Bi in the Ming Dynasty and the "Seven-Two Springs" of Hao Zhigong in the Qing Dynasty. The first of "Huquan Springs". It is one of the three spring groups in the world's first spring national AAAAA-level tourist attraction.</p>

                            <p className="grey-text">黑虎泉（Black Tiger Springs），位于山东省济南市历下区解放阁南护城河南岸陡崖下，在济南市黑虎泉东路。 
<br/><br/>
黑虎泉为一天然洞穴，高2米，深3米，宽1.7米，泉水主要来自洞穴的东南方向。洞穴由青石垒砌，洞穴隐露在岩壁下。泉池由石块砌成，略呈长方形，宽约17米，深约3米。泉池南壁并列3个石雕虎头。泉水流过暗沟，经3个石虎口喷出。 涌水量最大每日4.1万立方米，仅次于趵突泉。  附近有琵琶，溪中、九女等名泉14处，组成黑虎泉群。 
<br/><br/>
黑虎泉是金代《名泉碑》、明代晏璧《七十二泉诗》和清代郝植恭《七十二泉记》所著录的济南“七十二名泉”之一，居于“黑虎泉泉群”之首。为天下第一泉国家AAAAA级旅游景区三大泉群之一。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E9%BB%91%E8%99%8E%E6%B3%89/477141?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/09</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/38.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Woke up in the morning and took a taxi to Black Tiger Springs. Some people filled buckets in Baishi Spring.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title19">
                        <h4 className="tooltipped title" data-tooltip="趵突泉">Baotu Spring</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/19.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Baotu+Spring/@36.6610064,117.0009232,14z/data=!4m8!1m2!2m1!1z6La156qB5rOJ!3m4!1s0x35c205c79e68cb75:0xe1a3a6d3cd45906b!8m2!3d36.66119!4d117.015954">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Baotu Spring</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal19">Introduction</a>
                        <div id="modal19" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Baotu Spring - Introduction</h4>
                            <p>Baotu Spring, one of the three major scenic spots in Jinan, is located in Lixia District, Jinan City, Shandong Province. It faces Quancheng Square to the east and Wulongtan to the north. It covers an area of ​​158 acres and ranks first among the 72 famous springs in Jinan. During the Qianlong emperor's southern tour, the Baotu Spring water was mellow and sweet, and Baotu Spring was once designated as the "First Spring in the World". It is also the famous spring of Jinan first seen in ancient documents.
                            <br/><br/>
Baotu Spring is located in front of Luoyuan Hall in Baotu Spring Park. In the twentieth year of the Republic of China (1931), the surrounding stone banks were built. After several changes, a rectangular spring pool was formed, 30 meters long, 18 meters wide and 2.2 meters deep. It is bordered by Luoyuan Hall in the north, Guanlan Pavilion in the west, Laihe Bridge in the east, and a long corridor in the south. Spring water gushes from underground limestone caves, and 70,000 cubic meters of spring water gushes out every day. There are three water outlets for spring water, and the maximum water inflow is 162,000 meters per day. Baotu spring water is constant at around 18°C ​​throughout the year. The places of interest around Baotu Spring include Luoyuan Hall, Guanlan Pavilion, Shangzhi Hall, Li Qingzhao Memorial Hall, and Li Kuchan Memorial Hall.
<br/><br/>
Baotu Spring, Thousand Buddha Mountain and Daming Lake are also known as the three major scenic spots in Jinan. In 2013, the "First Spring Scenic Spot in the World" represented by Baotu Spring became a national AAAAA-level tourist attraction. On the afternoon of September 5, 2016, Baotu Springs Provincial Geopark was inaugurated and opened.</p>

                            <p className="grey-text">趵突泉（Baotu Spring），济南三大名胜之一，位于山东省济南市历下区，东临泉城广场，北望五龙潭，面积达158亩，位居济南七十二名泉之冠。乾隆皇帝南巡时因趵突泉水泡茶味醇甘美，曾册封趵突泉为“天下第一泉”。也是最早见于古代文献的济南名泉。 
<br/><br/>
趵突泉泉眼位于趵突泉公园内的泺源堂前。民国二十年（1931年）四周用石砌岸。几经变化，形成长方形泉池，长30米，宽18米，深2.2米。北临泺源堂，西傍观澜亭，东架来鹤桥，南有长廊围合。泉水从地下石灰岩溶洞中涌出，每天涌出7万立方米泉水，泉水有三个出水口，最大涌水量为16.2万米/天。趵突泉水一年四季恒定在18℃左右。趵突泉周边的名胜古迹有泺源堂、观澜亭、尚志堂、李清照纪念堂、李苦禅纪念馆等景点。
<br/><br/>
趵突泉与千佛山、大明湖并称为济南三大名胜。2013年，以趵突泉为代表的“天下第一泉景区”成为国家AAAAA级旅游景区。2016年9月5日下午，趵突泉泉群省级地质公园揭牌开园。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%B6%B5%E7%AA%81%E6%B3%89/162170?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/09</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/39.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Eating hot pot in Hang Lung Plaza at noon.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/40.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Baotu Spring Scenic Area</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/41.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p></p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/42.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Li Qingzhao Memorial Hall</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/43.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>In the evening, take the high-speed rail to Weifang.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title20">
                        <h4 className="tooltipped title" data-tooltip="风筝广场">Memorial of World Kite Capital</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/20.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Memorial+of+World+Kite+Capital/@36.7130936,119.0884907,14z/data=!4m8!1m2!2m1!1z5r2N5Z2K6aOO562d5bm_5Zy6!3m4!1s0x359519de16da5885:0x52475bf7f8916ab!8m2!3d36.705779!4d119.114859">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Memorial of World Kite Capital</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal20">Introduction</a>
                        <div id="modal20" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Memorial of World Kite Capital - Introduction</h4>
                            <p>Weifang Kite Plaza is located in the center of Weifang. It is a civic activity plaza that integrates civil air defense fortifications, commerce and shopping, leisure and entertainment, and highlights the "environmental protection", "humanistic characteristics" and "kite cultural characteristics". The total area is about 9 hectares, of which the upper square area of the first phase is about 48,000 square meters, and the lower riverside landscape area is about 9,500 square meters, totaling 57,500 square meters. The above-ground landscape of the square will be built with ten major landscapes including Mascot Avenue, Central Square, Riverside Scenic Area, Amphitheatre and Wharf, China World Trade Center Ladder Plaza, Siping Road Exit Plaza, Kite Museum Entrance Plaza, Children's Playground, Botanical Park, and Tree Array.</p>

                            <p className="grey-text">潍坊风筝广场位于潍坊市中心，是一个集人防工事、商贸购物、休闲娱乐等多功能于一体，凸现“环保特色”、“人文特色”和“风筝文化特色”的市民活动广场。总占地面积约9公顷，其中一期上部广场面积约48000平方米，下部滨河景观区面积约9500平方米，计57500平方米。广场地上景观将建设吉祥物大道、中心广场、滨河景观区、露天剧场与码头，国贸阶梯广场、四平路出口广场、风筝博物馆入口广场、儿童游戏场，植物公园、树阵等十大景观。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E9%A3%8E%E7%AD%9D%E5%B9%BF%E5%9C%BA/5783462?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/09</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/44.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Eat Hele.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/45.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>There were many people walking their dogs in the square.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title21">
                        <h4 className="tooltipped title" data-tooltip="吃喝玩乐">Fun</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/21.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Taihua+New+Plaza/@36.7131599,119.0884907,14z/data=!4m8!1m2!2m1!1z5rOw5Y2O5paw5aSp5Zyw576O6aOf6KGX!3m4!1s0x359519dce7159d69:0x3554596513157328!8m2!3d36.711015!4d119.112436">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Taihua Xintiandi</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        {/* <a className="btn-flat modal-trigger right info " href="#modal21">Introduction</a>
                        <div id="modal21" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">吃喝玩乐 - Introduction</h4>
                            <p>英吉利湾位于加拿大不列颠哥伦比亚省的温哥华市，在市区半岛和福溪附近。 它由Burrard入口的南侧组成，从西南的Point Grey延伸到东北的Prospect Point。
                            <br/>
                            <br/>
                            日落海滩位于西区，靠近伯拉德街大桥和温哥华国际旅馆。 温哥华水上运动中心位于日落海滩的东端，紧邻伯拉德街大桥的北端。 在温暖的月份，海滩上有救生员值班。 公共洗手间和特许摊位就在附近。 自行车道，步行道和直排轮滑道蜿蜒蜿蜒在海滩区上方，一个方向通往斯坦利公园，另一个方向通往耶鲁镇。 温哥华规模的游泳馆温哥华水上运动中心的南部有一个无牵引绳的区域。 这是观看温哥华烟花的热门地点。
                            </p>

                            <p className="grey-text">English Bay is located in Vancouver, British Columbia, Canada, west of the downtown peninsula and False Creek. It consists of the south side of the Burrard Inlet, extending from Point Grey in the southwest to Prospect Point in the northeast.
                            <br/>
                            <br/>
                            Sunset Beach is situated in the West End near the Burrard Street Bridge and Vancouver International Hostel. The Vancouver Aquatic Centre lies at the East end of Sunset beach right next to the North end of Burrard Street Bridge. The beach has lifeguards on duty in the warm months. Public washrooms and concession stands are nearby. Biking, walking and inline skating paths wind above the beach area, leading to Stanley Park in one direction and Yaletown in the other. There is an off leash area to the south of the Vancouver Aquatic Centre, an Olympic size natatorium. It is a popular location for watching Vancouver fireworks.</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/English_Bay,_Vancouver">
                                <span className="blue-text">[Source From...]</span>
                            </a>   
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div> */}

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/10</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/46.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Eat Huoshao.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/47.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Fly a kite.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/48.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Have a barbecue for dinner.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/49.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>After dinner, go to Taihua Xintiandi Food Street to buy snacks.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title22">
                        <h4 className="tooltipped title" data-tooltip="赶集">Go to the market</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/22.png" alt="" className="responsive-img"></img>
                                {/* <br></br>
                                <a href="">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">赶集</span>
                                </a> */}

                                
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        {/* <a className="btn-flat modal-trigger right info " href="#modal22">Introduction</a>
                        <div id="modal22" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">赶集 - Introduction</h4>
                            <p>布勒桥是加拿大卑诗省温哥华市内一条桁架桥，横越福溪的西端，连接温哥华市中心及基斯兰奴区。大桥现时有5条行车线，贯通两岸的布勒街，并设于行车线两旁设有行人及自行车通道。大桥的装饰艺术风格令其成为温市的主要地标之一。
                                <br/><br/>
                            格兰维尔街大桥不列颠哥伦比亚省温哥华的8车道大桥。大桥高27.4米，横跨福溪和格兰维尔岛。99号公路通行其上。此处原来的大桥于1889年建成。这是一座732米长的低矮木栈桥。靠近北端的通航孔是一个木桁架回转开启孔，两端由钢索斜拉挂在中央木塔上。大桥的主要设计由加拿大和平铁路公司完成，耗资一点六万美元。大桥于1891年改造加宽，在两侧设置了电车轨道，而在回转孔范围内，两侧的轨道交汇到了一起。第二座桥于1909年建成。这是一座更长的钢桥，通航孔是一个下承式桁架回转开启孔。
                            </p>

                            <p className="grey-text">Burrard Street Bridge is a truss bridge in Vancouver, British Columbia, Canada. It crosses the western end of False Creek and connects downtown Vancouver and Kitsilano District. The bridge currently has 5 traffic lanes running through Buller Street on both sides of the strait. Pedestrian and bicycle lanes are provided on both sides of the traffic lane. The Art Deco style of the bridge makes it one of the main landmarks of Vancouver.
                            <br/><br/>
                            Granville Bridge An 8-lane bridge in Vancouver, British Columbia. The bridge is 27.4 meters high and spans False Creek and Granville Island. Highway 99 runs through it. The original bridge here was completed in 1889. This is a low wooden trestle bridge with a length of 732 meters. The navigation hole near the north end is a wooden truss swing opening hole, and both ends are hung on the central wooden tower by steel cables. The main design of the bridge was completed by the Canadian Peace Railway Company at a cost of 16,000 US dollars. The bridge was remodeled and widened in 1891. Tram tracks were set on both sides, and within the revolving hole, the tracks on both sides merged together. The second bridge was completed in 1909. This is a longer steel bridge, and the navigation hole is a through-type truss turning opening hole.
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%B8%83%E5%8B%92%E6%A1%A5/14484441?fr=aladdin">
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div> */}

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                        <h5>2019/06/11</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/50.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Big dumplings.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title23">
                        <h4 className="tooltipped title" data-tooltip="风筝博物馆">World Kite Museum of Weifang</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/23.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Weifang+World+Kite+Museum/@36.7038033,119.1128323,17z/data=!3m1!4b1!4m5!3m4!1s0x359519dfce31bcbd:0x25cf44d280e85859!8m2!3d36.703799!4d119.115021">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">World Kite Museum of Weifang</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal23">Introduction</a>
                        <div id="modal23" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">World Kite Museum of Weifang - Introduction</h4>
                            <p>The World Kite Museum of Weifang (World Kite Museum of Weifang) is located at No. 66 Administrative Street, Kuiwen District, Weifang City, Shandong Province. It was officially completed on April 1, 1989 and opened to the public. In November 2003, it was under the management of Weifang Tourism Bureau. The first professional kite art museum.
                            <br/>
<br/>
The Weifang World Kite Museum covers a total area of 13,000 square meters, with a total construction area of 8,100 square meters. There are 12 large and small exhibition halls in the museum. There are more than 1,300 kite exhibits in the collection, showing various Chinese and foreign kites from the 5th century B. The style kite comprehensively shows the historical culture, modern culture, international culture and extended culture of the kite.
<br/>
<br/>
Weifang World Kite Museum is a national AAA tourist scenic spot. In January 2020, Weifang World Kite Museum was selected as "Shandong Province's Six Goods"</p>

                            <p className="grey-text">潍坊世界风筝博物馆（World Kite Museum of Weifang）位于山东省潍坊市奎文区行政街66号，于1989年4月1日正式竣工并对外开放，2003年11月归属潍坊市旅游局管理，为全国第一座风筝艺术类专业博物馆。
                            <br/>
<br/>
潍坊世界风筝博物馆总占地面积1.3万平方米，总建筑面积8100平方米，馆内共有大小展厅12个，馆藏风筝展品1300余件，展现了从公元前5世纪“鲁班风筝”至今的中外各式风筝，全面展示了风筝的历史文化、现代文化、国际文化及延伸文化。
<br/>
<br/>
潍坊世界风筝博物馆为国家AAA级旅游风景区。2020年1月，潍坊世界风筝博物馆入选“山东省'六好'齐赏好景景区”
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%BD%8D%E5%9D%8A%E4%B8%96%E7%95%8C%E9%A3%8E%E7%AD%9D%E5%8D%9A%E7%89%A9%E9%A6%86/9009221?fromtitle=%E9%A3%8E%E7%AD%9D%E5%8D%9A%E7%89%A9%E9%A6%86&fromid=1431244&fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>

                        </div>

                        <div className="titleContent">
                            <h5>2019/06/11</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/51.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>World Kite Museum of Weifang</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/52.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>In the evening, We ordered food, barbecue, beer takeaway in hotel.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title24">
                        <h4 className="tooltipped title" data-tooltip="十笏园">Shihuyuan Garden</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/24.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Weifang+Shihu+Garden+Museum/@36.7159973,119.0967512,15z/data=!4m8!1m2!2m1!1z5Y2B56yP5Zut!3m4!1s0x359519d004ac4c05:0xa77b1b399af89b8a!8m2!3d36.715327!4d119.105444">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Shihuyuan Garden</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal24">Introduction</a>
                        <div id="modal24" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Shihuyuan Garden - Introduction</h4>
                            <p>Shihuyuan Garden (Shihuyuan Garden), also known as Dingjia Garden, is located at No. 49 Hujiapaifang Street, Weicheng District, Weifang City, Shandong Province. ", hence the name "Ten Wat Garden".
                            <br/><br/>
The Shihu Garden is rectangular in plan and consists of three ancient architectural axes: the middle, west and east. The central axis building and its courtyard are the main part of the garden. The main building in the garden is the Yanxiang Building, which was built in the Ming Dynasty, with three bays and two floors. On the wall of the building, there are more than 90 original inscriptions of calligraphers and painters such as Zheng Banqiao and Jinnong. It is one of the small and exquisite gardens in the north of China.
<br/><br/>
In 1988, Shihu Garden was announced as the third batch of national key cultural relics protection units by the State Council.</p>

                            <p className="grey-text">十笏园（Shihuyuan Garden），又名丁家花园，位于山东省潍坊市潍城区胡家牌坊街49号，面积约2000平方米，因占地非常少，时人喻之为“十个笏板”，故得名“十笏园” 。
                            <br/><br/>
十笏园平面呈长方形，由中、西、东三条古建筑轴线组成，中轴线建筑及其院落为园之主体部分，园内的主要建筑砚香楼，始建于明代，三开间，二层楼，墙壁上嵌有郑板桥、金农等书画家的真迹碑刻90余方，是中国北方地区具有江南园林小巧玲珑特色的园林之一 。
<br/><br/>
1988年，十笏园被国务院公布为第三批全国重点文物保护单位。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%8D%81%E7%AC%8F%E5%9B%AD/779498?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/12</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/53.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Eat Chaotianguo.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/54.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Shihuyuan Garden</p>
                                </div>
                            </div>





                        </div>
                        
                    </div>

                    <div className="titles" id="title25">
                        <h4 className="tooltipped title" data-tooltip="关帝庙">Guandi Temple</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/25.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Guandi+Temple,+Qingzhou,+Weifang,+Shandong,+China/@36.5973554,118.6971152,15z/data=!3m1!4b1!4m5!3m4!1s0x35954b1186135e27:0xc87baa02e0b4192a!8m2!3d36.597339!4d118.70587">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Guandi Temple</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        {/* <a className="btn-flat modal-trigger right info " href="#modal25">Introduction</a>
                        <div id="modal25" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">关帝庙 - Introduction</h4>
                            <p>关帝庙位于温哥华Gastown街区的Cambie和Water街的转角处。 这个钟的来历很有趣。当年的水街采用蒸汽集中供热，一条条供热管将中心锅炉产生的热蒸汽输送到各家各户。为了散去多余的蒸汽，人们不得不在街上开了3个散蒸汽口，可其中一个恰好位于最繁华的水街路口，既不雅观，也不方便。1854年，一个叫桑德斯的聪明人巧妙地利用这个散蒸汽口的废蒸汽，建成了这座当时世界上独一无二的关帝庙。</p>

                            <p className="grey-text">The Steam Clock is located at the corner of Cambie and Water Streets in the Gastown neighborhood of Vancouver. The origin of this clock is very interesting. At that time, the water street used steam central heating, and the heating pipes transported the hot steam produced by the central boiler to each household. In order to dissipate the excess steam, people had to open three steam outlets on the street, but one of them happened to be located at the most prosperous Shuijie intersection, which was both unsightly and inconvenient. In 1854, a clever man named Sanders cleverly used the waste steam from the steam outlet to build this unique steam clock in the world at that time.</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%92%B8%E6%B1%BD%E9%92%9F/2987407?fr=aladdin">
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div> */}

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                        <h5>2019/06/12</h5>
                        <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/55.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Arrive in Penglai by car in the afternoon and order takeaway dinner at the hotel.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title26">
                        <h4 className="tooltipped title" data-tooltip="蓬莱阁">Penglai Pavilion</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/26.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Maple+Tree+Square,+Vancouver,+BC/@49.2834016,-123.1061831,17z/data=!3m1!4b1!4m5!3m4!1s0x548671774ec789ed:0x8f0ba62a2d67e218!8m2!3d49.2833664!4d-123.104129">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Penglai Pavilion</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal26">Introduction</a>
                        <div id="modal26" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Penglai Pavilion - Introduction</h4>
                            <p> Penglai Pavilion, located in Penglai District, Yantai City, Shandong Province, is an ancient architectural complex. The main building of Penglai Pavilion was built in the sixth year of Jiayou in the Song Dynasty (1061). It is known as the "Wonderland on Earth", and its legend of "Eight Immortals Crossing the Sea" and "mirage of the sea" are well-known at home and abroad.
                            <br/><br/>
Penglai Pavilion has gone through the vicissitudes of wind and rain, and now it has developed into an ancient building complex as its central axis, Penglai Water City and Tian Hengshan as its two wings, four cultures (fairy culture, Jingwu culture, port culture, ocean culture) as the foundation, mountain (Danya Mountain) , Sea (Yellow and Bohai Sea), City (Penglai Water City), Pavilion (Penglai Pavilion) are the layouts, and more than 20 scenic spots such as Dengzhou Museum, Ancient Ship Museum, Tian Hengshan, Hehai Pavilion and the boundary coordinates of the Yellow and Bohai Sea are dotted. It is a scenic spot and leisure resort integrating natural scenery, historical sites, cultural landscapes, leisure and entertainment.</p>

                            <p className="grey-text">蓬莱阁，位于山东省烟台市蓬莱区，是一处古建群。蓬莱阁的主体建筑建于宋朝嘉祐六年（1061年），素以“人间仙境”著称于世，其“八仙过海”传说和“海市蜃楼”奇观享誉海内外。 
<br/><br/>
蓬莱阁历经风雨沧桑，如今已发展成以古建筑群为中轴，蓬莱水城和田横山为两翼，四种文化（神仙文化、精武文化、港口文化、海洋文化）为底蕴，山（丹崖山） 、海（黄渤二海）、城（蓬莱水城）、阁（蓬莱阁）为格局，登州博物馆、古船博物馆、田横山、合海亭及黄渤海分界坐标等20余处景点为点缀，融自然风光、历史名胜、人文景观、休闲娱乐于一体的风景名胜区和休闲度假胜地。
                            
                           </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%93%AC%E8%8E%B1%E9%98%81/63337?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/13</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/56.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Porridge</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/57.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Dengzhou Ancient Ship Museum</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/58.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Penglai Pavilion Scenic Area - Tian Heng Mountain</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title27">
                        <h4 className="tooltipped title" data-tooltip="海洋极地世界">Ocean Aquarium of Penglai</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/27.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Ocean+Aquarium+of+Penglai/@37.8256692,120.7445743,17z/data=!3m1!4b1!4m5!3m4!1s0x3591b0305e279669:0xab5d8e2f62b3ec1c!8m2!3d37.825665!4d120.746763">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Ocean Aquarium of Penglai</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal27">Introduction</a>
                        <div id="modal27" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Ocean Aquarium of Penglai - Introduction</h4>
                            <p>              Penglai Ocean Polar World is located at the foot of Danya Mountain in Penglai, adjacent to the famous Penglai Pavilion. It was built by Penglai Haifeng Industrial Co., Ltd. with an investment of 460 million. It is a collection of ornamental, entertaining, interesting, thrilling and reflective marine culture A comprehensive exhibition hall integrating science and technology. The entire exhibition area covers an area of 51,800 square meters, and is divided into 14 exhibition halls, including tropical rainforest pavilion, polar pavilion, shark pavilion, dolphin and sea lion performance hall, turtle pavilion, seal pavilion, underwater theater, four-dimensional dynamic cinema, multimedia exhibition hall From the equatorial tropical rain forest to the polar regions of the Arctic Ocean, there are more than a thousand species of rare marine life around the world.</p>

                            <p className="grey-text">蓬莱海洋极地世界坐落于蓬莱丹崖山下，与著名的蓬莱阁毗邻，由蓬莱海锋实业有限公司投资4.6亿建设，是一个集观赏性、娱乐性、趣味性、惊险刺激和反映海洋文化、海洋科技为一体的综合性展馆。整个展区面积5.18万平方米，分为热带雨林馆、极地馆、鲨鱼馆、海豚海狮表演馆、海龟馆、海豹馆、水下剧场、四维动感影院、多媒体展览馆等14个展馆，汇集了从赤道热带雨林到北冰洋极地世界各地珍稀海洋生物千余种。
              </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%93%AC%E8%8E%B1%E6%B5%B7%E6%B4%8B%E6%9E%81%E5%9C%B0%E4%B8%96%E7%95%8C/10095766?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/13</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/59.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Ocean Aquarium of Penglai is next to Penglai Pavilion, walk to it.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/60.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Mermaid Performance.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/61.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Dolphin and sea lion show.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/62.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Dinner</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title28">
                        <h4 className="tooltipped title" data-tooltip="九丈崖">Jiuzhangya Park</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/28.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E9%95%BF%E5%B2%9B%E4%B9%9D%E4%B8%88%E5%B4%96/@37.921417,120.7015651,13z/data=!4m11!1m2!2m1!1z5Lmd5LiI5bSW!3m7!1s0x3591b70d1fd19f23:0xb0e8c3c685cfe7e7!5m2!4m1!1i2!8m2!3d37.921417!4d120.736584">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Jiuzhangya Park</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal28">Introduction</a>
                        <div id="modal28" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Jiuzhangya Park - Introduction</h4>
                            <p>Jiuzhangya is named because of the high and steep cliffs. The existing Jiuzhangya Park covers an area of 3,000 square meters. There are: one, Pearl Tunnel; two bays, Pearl Bay and Ouchi Bay; Three Cliffs , Namely Stone Pagoda Cliff, Jiuzhang Cliff, Longpan Cliff; four platforms, namely observation deck, fishing platform, dressing table, and Dianjiang platform; five holes, namely Sanyuan Cave, Luzu Cave, Xiangu Cave, Shrimp Cave, Qixian Cave ; Six reefs, namely Incense Burner Reef, Pearl Reef, Threshold Reef, Warship Reef, Seal Reef, Wolong Reef; Seven Stones, namely nine-fold stone, crystal stone, longevity stone, ghost stone, chessboard stone, random thought stone, triple jumping stone And other major attractions.</p>

                            <p className="grey-text">由于崖壁的高且险峻而得名的九丈崖，现建九丈崖公园总占地面积3000平方米，有：一道，即珍珠隧道；二湾，即珍珠湾、鸥翅湾；三崖，即石塔崖、九丈崖、龙盘崖；四台，即观景台、垂钓台、梳妆台、点将台；五洞，即三元洞、吕祖洞、仙姑洞、虾精洞、七仙洞；六礁，即香炉礁、珍珠礁、门槛礁、军舰礁、海狗礁、卧龙礁；七石，即九叠石、水晶石、长寿石、鬼爷石、棋盘石、随想石、三跳石等主要景点。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E4%B9%9D%E4%B8%88%E5%B4%96%E9%A3%8E%E6%99%AF%E5%8C%BA/7295153?fromtitle=%E4%B9%9D%E4%B8%88%E5%B4%96&fromid=6575719&fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/14</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/63.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Breakfast - takeaway ordered at the hotel.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/64.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>dock</p>
                                    <p>Go to Changdao by ship</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/65.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Jiuzhangya Park</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/66.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Jiuzhangya Park</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/67.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Jiuzhangya Park</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>

                    <div className="titles" id="title29">
                        <h4 className="tooltipped title" data-tooltip="月牙湾">Yueyawan Park</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/29.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Yueyawan+Park/@37.9859752,120.7142453,17z/data=!3m1!4b1!4m5!3m4!1s0x3591c8093e4f1c9d:0x3886571a6e505461!8m2!3d37.985971!4d120.716434">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Yueyawan Park</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal29">Introduction</a>
                        <div id="modal29" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Yueyawan Park - Introduction</h4>
                            <p>Crescent Bay, also known as Half Moon Bay, is located at the northernmost tip of North Changshan Island in Changdao County. It naturally forms the Crescent Long Beach with a length of about 2,000 meters. It is named after the bay is shaped like a half moon. It is backed by green mountains and green fields, surrounded by blue seas and clear waves, and a long beach of silver and white balls, embedded in the green mountains and blue water, is like a crescent moon in the deep night sky.</p>

                            <p className="grey-text">月牙湾又称半月湾，坐落于长岛县北长山岛最北端，自然形成长约2000米的月牙长滩，因湾形似半月而得名。它背依青山绿野，环抱碧海清波，一袭银白球石的遥遥长滩，镶嵌在青山碧水之间，犹如深邃夜空中的一弯新月。
</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%9C%88%E7%89%99%E6%B9%BE/79523?fr=aladdin">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>     
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                            <h5>2016/07/01</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img12/5.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>随后我来到英吉利湾和日落海滩。温哥华的气候非常温暖舒适，人们三三两两悠闲自在地坐在海滩边。</p>
                                    <p>我沿着海岸线从北走到南，吹着海风，十分惬意。</p>
                                </div>
                            </div>



                        </div> */}
                        
                    </div>

                    <div className="titles" id="title30">
                        <h4 className="title" >Xianjingyuan</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img23/30.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E9%95%BF%E5%B2%9B%E9%BB%84%E6%B8%A4%E6%B5%B7%E5%88%86%E7%95%8C%E7%BA%BF/@37.9269402,120.7427833,17z/data=!3m1!4b1!4m5!3m4!1s0x3591b7a792c18647:0x86a110efe5a3eaad!8m2!3d37.926936!4d120.744972">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Yellow Sea and Bohai Sea boundary</span>
                                </a>

                                
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal30">Introduction</a>
                        <div id="modal30" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Yellow Sea and Bohai Sea boundary - Introduction</h4>
                            <p>This is the magnificent scene of the natural boundary between the Yellow Sea and the Bohai Sea in Laotie Mountain. Lao Tie Shan Jiao, located at the tip of the Liaodong Peninsula, extends between the Yellow Sea and the Bohai Sea, forming the natural boundary between the Yellow Sea and the Bohai Sea. The color of the sea water can be described as “clearly distinct”. Part of the Yellow Sea in the east is dark blue, while the Bohai Sea in the west is turbid and slightly yellow. This is because of the natural phenomenon formed by the seabed trench.</p>

                            <p className="grey-text">“老铁山头入海深，黄海渤海自此分。西去急流如云涌，南来薄雾应风生”。此即为地处老铁山的黄海和渤海自然分界的壮观景象。 老铁山角，位于辽东半岛的尖端，延伸黄海和渤海之中，形成黄海和渤海的自然分界，在海水的颜色上可谓“泾渭分明”。东部黄海部分水是深蓝色，而西部渤海水却显得浑浊，略呈微黄色。这是因为所处海底地沟所形成的自然现象。
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E9%BB%84%E6%B8%A4%E6%B5%B7%E5%88%86%E7%95%8C%E7%BA%BF/8691230?fr=aladdin">
                                <span className="blue-text">[Source From...]</span>
                            </a>   
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2019/06/14</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/68.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Yellow Sea and Bohai Sea boundary</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/69.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Return to Penglai.</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img24/70.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Have crayfish hot pot for dinner.</p>
                                    <p>See you next time, Shanxi, Shandong.</p>
                                </div>
                            </div>



                        </div>
                        
                    </div>


                    <h4 className="title"> </h4>

                    {/* <div className="Comment">
                    
                        <div className="row">   
                        <div className="col s1 m1 l1">
                            <a className="btn btn-floating black lighten-1 ">YX</a>
                        </div>
                        <div className="col s11 m11 l11 commentContent">
                            <form action="">
                                <div className="input-field">
                                    <textarea id="message" className="materialize-textarea"></textarea>
                                    <label htmlFor="message">发表评论</label>
                                </div>
                            </form>
                        </div>
                        </div>

                      

                    </div> */}
       


                </div>
            </div>

            <div className="row hide-on-med-and-up" id="travelNoteShanxiShandong">

<div className="col s12 m12 l12 noteShanxiShandong">


<a href="" className="sidenav-trigger" data-target="mobile-menu999">
        <i className="material-icons smallnotenav" >menu</i>
    </a>
    <ul className="sidenav grey lighten-2 sidenav999" id="mobile-menu999">
    <div className="bigTitle">Shandong&Shanxi</div>
            <li className="titleDate">
                <a href="#title31">2019/06/03</a>
            </li>
            <li className="smallTitle">
                <a>Taiyuan-<a href="#title31" className="verysmallTitle">Jinci</a>/<a href="#title32" className="verysmallTitle">Cuyuan</a>/<a href="#title33" className="verysmallTitle">Yingze</a></a>

            </li>

            <li className="titleDate">
                <a href="#title34">2019/06/04</a>
            </li>
            <li className="smallTitle">
                <a>Taiyuan-<a href="#title34" className="verysmallTitle">Wang</a>/<a href="#title35" className="verysmallTitle">PingYao</a></a>

            </li>

            <li className="titleDate">
                <a href="#title36">2019/06/05</a>
            </li>
            <li className="smallTitle">
                <a>Taiyuan-<a href="#title36" className="verysmallTitle">Temple</a>/Datong-<a href="#title37" className="verysmallTitle">Datong</a></a>

            </li>

            <li className="titleDate">
                <a href="#title38">2019/06/06</a>
            </li>
            <li className="smallTitle">
                <a>Datong-<a href="#title38" className="verysmallTitle">Temple</a>/<a href="#title39" className="verysmallTitle">Heng</a>/<a href="#title40" className="verysmallTitle">Grottoes</a></a>

            </li>

            <li className="titleDate">
                <a href="#title41">2019/06/07</a>
            </li>
            <li className="smallTitle">
                <a>Datong-<a href="#title41" className="verysmallTitle">Wall</a>/<a href="#title42" className="verysmallTitle">Mosque</a>/<a href="#title43" className="verysmallTitle">Huayan</a></a>

            </li>

            <li className="titleDate">
                <a href="#title44">2019/06/08</a>
            </li>
            <li className="smallTitle">
                <a>Jinan-<a href="#title44" className="verysmallTitle">Daming</a>/<a href="#title45" className="verysmallTitle">Mountain</a>/<a href="#title46" className="verysmallTitle">Kuanhouli</a>/<a href="#title47" className="verysmallTitle">Furong</a></a>

            </li>
                    <br/>

            <li className="titleDate">
                <a href="#title48">2019/06/09</a>
            </li>
            <li className="smallTitle">
                <a>Jinan-<a href="#title48" className="verysmallTitle">Springs</a>/<a href="#title49" className="verysmallTitle">Baotu</a>/Weifang-<a href="#title50" className="verysmallTitle">Kite</a></a>

            </li>
            <br/>
            <li className="titleDate">
                <a href="#title51">2019/06/10</a>
            </li>
            <li className="smallTitle">
                <a>Weifang-<a href="#title51" className="verysmallTitle">Fun</a></a>

            </li>

            <li className="titleDate">
                <a href="#title52">2019/06/11</a>
            </li>
            <li className="smallTitle">
                <a>Weifang-<a href="#title52" className="verysmallTitle">Market</a>/<a href="#title53" className="verysmallTitle">Kite Museum</a></a>

            </li>

            <li className="titleDate">
                <a href="#title54">2019/06/12</a>
            </li>
            <li className="smallTitle">
                <a>Weifang-<a href="#title54" className="verysmallTitle">Shihuyuan</a>/<a href="#title55" className="verysmallTitle">Guandi</a></a>

            </li>

            <li className="titleDate">
                <a href="#title56">2019/06/13</a>
            </li>
            <li className="smallTitle">
                <a>Penglai-<a href="#title56" className="verysmallTitle">Penglai</a>/<a href="#title57" className="verysmallTitle">Aquarium</a></a>

            </li>

            <li className="titleDate">
                <a href="#title58">2019/06/14</a>
            </li>
            <li className="smallTitle">
                <a>Changdao-<a href="#title58" className="verysmallTitle">Jiuzhangya</a>/<a href="#title59" className="verysmallTitle">Yueyawan</a>/<a href="#title60" className="verysmallTitle">Xianjingyuan</a></a>

            </li>
        
    </ul>



        <div className="row">
            <div className="col s10 m10 l10 offset-s1 offset-m1 offset-l1 ">
            <div className="row travelDetail">
                <div className="time col s12 m4 l4">
                    <i className=" material-icons left">access_time</i>
                    <span>Departure</span>
                    <span> / </span>
                    <span>2019-06-02</span>
                </div>
                <div className="day col s12 m4 l4">
                    <i className=" material-icons left">wb_sunny</i>
                    <span>Travel Days</span>
                    <span> / </span>
                    <span>14 days</span>
                </div>
                <div className="people col s12 m4 l4">
                    <i className=" material-icons left">account_circle</i>
                    <span>People</span>
                    <span> / </span>
                    <span>With Friends</span>
                </div>
            </div>
            <div className="col s1 m1 l1"></div>
            </div>
        </div>
        <div className="titles" id="title31">
<h4 className="tooltipped title" data-tooltip="晋祠">Jinci Temple</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/1.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Jinci/@37.6987932,112.4340342,15z/data=!4m8!1m2!2m1!1z5pmL56Wg!3m4!1s0x36755217421cda9f:0x1476f8d4b4f18d30!8m2!3d37.70674!4d112.447623">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Jinci Temple</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9991">Introduction</a>
<div id="modal9991" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Jinci Temple - Introduction</h4>
    <p>Jinci, located in Jinci Town, Jinyuan District, Taiyuan City, Shanxi Province, was originally named Jinwangci and was originally named Tang Shuyu Temple. It was built to commemorate Tang Shuyu, the founding prince of the Jin Dynasty (later named Jin King) and his mother, Jianghou.
<br/>
<br/>
Among them, the old fountain, the statue of the maid, and the statue of the virgin are known as the "Three Wonders of Jinci". Jinci is the earliest surviving royal sacrificial garden in China, the Jin State ancestral hall; it is an intensive carrier of ancient Chinese architectural art. It is an isolated example of the main building types and epoch sequence from Song, Yuan, Ming and Qing to the Republic of China. The attached colored sculptures and murals and steles are national treasures; The comprehensive carrier of historical context, the Jin cultural system traces back to the empirical evidence of the cultural inheritance of the Western Zhou Dynasty, the feudal Tang Jian Jin to the prime Tang Zhaochuang; it is the birthplace of the Wang and Zhang clan in the world.
<br/>
<br/>
In March 1961, Jinci was announced by the State Council as the first batch of national key cultural relics protection units. In 2001, it was rated as the first batch of AAAA-level tourist attractions by the National Tourism Administration. In May 2009, it was approved as a national secondary museum by the State Administration of Cultural Heritage.</p>

    <p className="grey-text">晋祠，位于山西省太原市晋源区晋祠镇，原名为晋王祠，初名唐叔虞祠，是为纪念晋国开国诸侯唐叔虞（后被追封为晋王）及母后邑姜后而建。
<br/>
<br/>
其中难老泉、侍女像、圣母像被誉为“晋祠三绝”。晋祠是中国现存最早的皇家祭祀园林，晋国宗祠；是中国古代建筑艺术的集约载体，国内宋元明清至民国本体建筑类型、时代序列完整的孤例，附属彩塑壁画碑碣均为国宝；是三晋历史文脉的综合载体，晋文化系统上溯西周封唐建晋至盛唐肇创文脉传承的实证；是世界王氏、张氏发祥地。 
<br/>
<br/>
1961年3月，晋祠被国务院公布为第一批全国重点文物保护单位。2001年，被国家旅游局评为首批AAAA级旅游景区。2009年5月，被国家文物局批准为国家二级博物馆。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%99%8B%E7%A5%A0/128888?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/03</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/1.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Arrived in Taiyuan on the evening of the 2nd and stayed at the Orange Hotel on South Inner Ring Street.

</p>
            <p>On the morning of the 3rd, have breakfast nearby.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/2.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Take a taxi to Jinci</p>
            <p>

There are many tour guides at the gate of Jinci, you can ask one to explain if you need it.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/3.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>NanLao Spring</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title32">
<h4 className="tooltipped title" data-tooltip="东湖醋园">Donghucu Sales Department</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/2.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Donghucu+Sales+Department/@37.8795888,112.5945617,17z/data=!3m1!4b1!4m5!3m4!1s0x360aa83862ac1b07:0xcdfde1cd3fe8c178!8m2!3d37.8795846!4d112.5967504">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Donghucu Sales Department</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9992">Introduction</a>
<div id="modal9992" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Donghucu Sales Department - Introduction</h4>
    <p>The exhibition hall and vinegar therapy garden of Donghu Vinegar Garden. Collected various vinegar brewing utensils, farming utensils and more than 700 vinegar therapy prescriptions since the Western Han Dynasty of our country. The historical and cultural heritage of Shanxi old vinegar is fully displayed in the form of ancient and modern utensils, excerpts from literature, pictures, photos, and physical products. . Near the antique building Meihe Ju Vinegar Workshop, oncoming is the sour and fragrant old vinegar smell.
    <br/>
<br/>
Entering the quaint Meiheju vinegar workshop is like coming to an old vinegar workshop 500 years ago. The old vinegar is fragrant, tangy, and full of vinegar, which is unforgettable. The craftsmanship and steps of "steaming, fermenting, fumigating, drenching and drying" old aged vinegar are at a glance in the workshop. Visitors can participate in part of the production process or enjoy the "sweet, sour, fragrant, sweet and fresh" feeling of old aged vinegar. respectable.
    
    
</p>

    <p className="grey-text">东湖醋园的陈列堂和醋疗园。分别收集了我国西汉以来各种酿醋器具、农耕器具和700余个醋疗药方，以古今器皿展示、文献典籍摘记，图片照片写真，产品实物陈列等形式充分展示了山西老陈醋的历史文化底蕴。临近仿古建筑美和居醋坊，迎面而来的是既酸又香的老陈醋气味。
<br/>
<br/>
进入古色古香的美和居醋坊，犹如来到了500年前的老陈醋作坊，老醋芳香、扑鼻沁心，醋味十足，难以忘怀。作坊内“蒸、酵、熏、淋、晒”的老陈醋制作工艺和步骤一览无余，游客参与部分制作过程或者尽兴品尝老陈醋“绵、酸、香、甜、鲜”之感的姿态可亲可敬。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E4%B8%9C%E6%B9%96%E9%86%8B%E5%9B%AD/9584213?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/03</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/4.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Take a taxi to the Donghucu Sales Department.</p>
            <p>

Here you can see the vinegar brewing process and taste the vinegar of different years.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/5.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Have lunch at Maoye Tiandi at noon.</p>
        </div>
    </div>


    




</div>

</div>

<div className="titles" id="title33">
<h4 className="tooltipped title" data-tooltip="迎泽公园">Yingze Park</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/3.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Yingze+Park/@37.8550382,112.5600673,17z/data=!3m1!4b1!4m5!3m4!1s0x360aa90e6f9adefb:0x5dccc24927d6fc4!8m2!3d37.855034!4d112.562256">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Yingze Park</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9993">Introduction</a>
<div id="modal9993" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Yingze Park - Introduction</h4>
    <p>Yingze Park is the largest park in Taiyuan, named after it is located outside the Yingze Gate of the ancient Taiyuan City. The total area of Yingze Park is 666,900 square meters, and the water surface of Yingze Lake occupies one third of the total area. It mainly includes popular science areas, scenic spots and amusement areas. Yingze Park was officially opened in June 1957.
    </p>

    <p className="grey-text">迎泽公园是太原市内最大的公园，因位于古太原城迎泽门外而得名。迎泽公园总面积666900平方米，迎泽湖水面占总面积的三分之一，主要有科普区、风景区以及游乐区域。迎泽公园于1957年6月正式开放。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%BF%8E%E6%B3%BD%E5%85%AC%E5%9B%AD/3170614?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/03</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/6.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Yingze Park</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/7.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Eat Taiyuan cuisine at the old Taiyuan restaurant for dinner.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/8.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Take a walk in Taiyuan (Fenhe) at night.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/9.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Get a massage before going back to the hotel.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title34">
<h4 className="tooltipped title" data-tooltip="王家大院">Wang Family Courtyard</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/4.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E7%8E%8B%E5%AE%B6%E5%A4%A7%E9%99%A2/@36.896145,111.3142943,9z/data=!4m8!1m2!2m1!1z546L5a625aSn6Zmi!3m4!1s0x3675cab952f23bdd:0xa8da9991f30f827f!8m2!3d36.896145!4d111.874597">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Wang Family Courtyard</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9994">Introduction</a>
<div id="modal9994" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Wang Family Courtyard - Introduction</h4>
    <p>The Wang Family Courtyard is located in Jingsheng Town, a famous Chinese historical and cultural town 12 kilometers east of Lingshi County, Shanxi Province. It is 35 kilometers away from the world cultural heritage Pingyao Ancient City and 4 kilometers away from Jiexiu Mianshan Mountain.
    <br/>
<br/>
The Wang Family Courtyard was built by the Jingsheng Wang family through the Ming and Qing dynasties for more than 300 years. It includes five lanes and six castles and a street with a total area of 250,000 square meters. It is an architectural art museum with traditional cultural characteristics. . It is a national key cultural relics protection unit and a 4A-level scenic spot.</p>

    <p className="grey-text">王家大院位于山西省灵石县城东12公里处的中国历史文化名镇静升镇。距世界文化遗产平遥古城35公里、介休绵山4公里。
<br/>
<br/>
王家大院是由静升王氏家族经明清两朝、历300余年修建而成，包括五巷六堡一条街，总面积达25万平方米，而且是一座具有传统文化特色的建筑艺术博物馆。它是全国重点文物保护单位和4A级景区。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E7%8E%8B%E5%AE%B6%E5%A4%A7%E9%99%A2/196361?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/04</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/10.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Order a breakfast takeaway at the hotel.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/11.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Contracted a car.</p>
            <p>Arrive at the Wang Family Courtyard first.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/12.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Wang Family Courtyard</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/13.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>A big monkey in the front is gnawing a birthday peach, and a little monkey is behind him. It’s worth noting that the hands of the two monkeys were naughty covering their ears, which meant that they were telling the descendants of the Wang family to "keep their ears off the window and read only the sage books", and they were also telling their tribesmen whether to manage the house or govern the country. It should be done "Do not listen to evil."</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/14.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p></p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/15.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p></p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title35">
<h4 className="tooltipped title" data-tooltip="平遥古城">The AncientCity of Ping Yao</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/5.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Pingyao,+Jinzhong,+Shanxi,+China/@37.1396179,111.9656037,10z/data=!3m1!4b1!4m5!3m4!1s0x36750a69fc81187f:0xeaf4b4528d55f07e!8m2!3d37.189822!4d112.176206">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">The AncientCity of Ping Yao</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9995">Introduction</a>
<div id="modal9995" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">The AncientCity of Ping Yao - Introduction</h4>
    <p>The ancient city of Pingyao is located in the central part of Shanxi Province. It was built in the reign of King Zhou Xuan and expanded in the third year of Hongwu in the Ming Dynasty (1370). It has a history of more than 2,700 years. It still retains the basic features of the county in the Ming and Qing Dynasties. It is the most complete ancient city in the Han ethnic region in China.
    <br/>
<br/>
Pingyao, Shanxi is known as one of the "four best-preserved ancient cities", and it is also one of the only two ancient cities in China that has successfully declared its entire ancient city as a world cultural heritage.
<br/>
<br/>
The World Heritage Center describes: Pingyao Ancient City is an outstanding example of ancient Chinese cities in the Ming and Qing Dynasties, and Pingyao Ancient City has preserved all its characteristics. Moreover, in the development of Chinese history, it showed people a complete picture of extraordinary cultural, social, economic and religious development.</p>

    <p className="grey-text">平遥古城位于山西省中部，始建于周宣王时期，明洪武三年（1370年）扩建，距今已有2700多年的历史。还较为完好地保留着明清时期县城的基本风貌，是中国汉民族地区现存最为完整的古城。 
<br/>
<br/>
山西平遥被称为“保存最为完好的四大古城”之一，也是中国仅有的以整座古城申报世界文化遗产获得成功的两座古城市之一。 
<br/>
<br/>
世界遗产中心描述称：平遥古城是中国古代城市在明清时期的杰出范例，平遥古城保存了其所有特征。而且，在中国历史的发展中，为人们展示了一幅非同寻常的文化、社会、经济及宗教发展的完整画卷。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%B9%B3%E9%81%A5%E5%8F%A4%E5%9F%8E/791?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/04</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/16.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Ancient City Wall</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/17.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>There are many types of pasta in Shanxi.</p>
            <p>

Dinner was in the Shanxi Guild Hall, and the running man also recorded in this Shanxi Guild Hall.</p>
        </div>
    </div>


</div>

</div>

<div className="titles" id="title36">
<h4 className="tooltipped title" data-tooltip="双塔寺">Twin Pagoda Temple</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/6.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Twin+Pagoda+Temple/@37.8452152,112.5975463,17z/data=!3m1!4b1!4m5!3m4!1s0x360aa9ea66014027:0x758e6f347c24b92a!8m2!3d37.845211!4d112.599735">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Twin Pagoda Temple</span>
        </a>

        
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9996">Introduction</a>
<div id="modal9996" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Twin Pagoda Temple - Introduction</h4>
    <p>The Twin Towers of Yongzuo Temple, also known as Lingxiao Twin Towers, are the tallest existing ancient buildings in Taiyuan, the capital of Shanxi. Located at the foot of the mountain in the southeast of Taiyuan City. The two towers in Yongzuo Temple are like a pair of twin sisters. The Lingxiao Twin Towers also have a beautiful nickname-the two peaks of writing and writing.
    <br/><br/>
These two sister towers are twin towers, one is the "WenFeng Pagoda" built first, and the other is the "SheLi Pagoda" built later. The towering twin towers are the tallest in my country.
    
    </p>

    <p className="grey-text">永祚寺双塔，又名凌霄双塔，是山西省会太原现存古建筑中最高的建筑。位于太原市城区东南向山脚畔。永祚寺内的两塔犹如一对孪生姊妹，相映成趣。凌霄双塔还有一个美丽动听的别称—文笔双峰。 
    <br/><br/>
这两座形同孪生的姊妹塔，一个是先建的“文峰塔”，一个是后建的“舍利塔”。双塔巍峨俊秀，是我国双塔之最。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%B0%B8%E7%A5%9A%E5%AF%BA%E5%8F%8C%E5%A1%94/10421244?fromtitle=%E5%8F%8C%E5%A1%94%E5%AF%BA&fromid=16814&fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/05</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/18.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Ascending to the top, the tower is really narrow and steep.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title37">
<h4 className="tooltipped title" data-tooltip="大同古城">Datong Ancient City</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/7.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E5%A4%A7%E5%90%8C%E5%9F%8E%E5%A2%99/@40.08546,113.2454043,12z/data=!4m8!1m2!2m1!1z5aSn5ZCM5Y-k5Z-O!3m4!1s0x35e2d45c674b730b:0x78a9bb6882503e14!8m2!3d40.0853498!4d113.3154445">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Datong Ancient City</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9997">Introduction</a>
<div id="modal9997" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Datong Ancient City - Introduction</h4>
    <p>The ancient city wall of Datong was built on the old soil city of Yuangu city wall in the fifth year of Hongwu in Ming Dynasty (1372), and it is quite famous throughout the country. The total perimeter of the city wall of Datong is 7270.7 meters, forming a square city.
    </p>

    <p className="grey-text">大同古城墙为明洪武五年(1372年)在元故城墙旧土城上增筑而成，全国颇有名气。大同城墙的总周长为7270．7米，形制方形城池。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%A4%A7%E5%90%8C%E5%8F%A4%E5%9F%8E%E5%A2%99/2445538?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>

<div className="titleContent">
    <h5>2019/06/05</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/19.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Dongfang noodles</p>
        </div>
    </div>



</div>


</div>

<div className="titles" id="title38">
<h4 className="tooltipped title" data-tooltip="悬空寺">Hanging Temple</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/8.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E6%82%AC%E7%A9%BA%E5%AF%BA/@39.658174,113.6948065,14z/data=!4m8!1m2!2m1!1z5oKs56m65a-6!3m4!1s0x35e3143512ab84c3:0x7ef5f694a4d2797f!8m2!3d39.658174!4d113.712316">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Hanging Temple</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9998">Introduction</a>
<div id="modal9998" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Hanging Temple - Introduction</h4>
    <p>Xuankong Temple(Hanging Temple), located between the cliffs of Cuiping Peak on the west side of Jinlong Gorge of Hengshan Mountain, Hunyuan County, Datong City, Shanxi Province, was originally called "Xuankong Pavilion". "Xuan" is derived from Chinese Taoist teachings, and "empty" is derived from Buddhist teachings. It was later renamed "Xuankong Temple" because the whole temple seemed to hang on a cliff. In Chinese, "Xuan" and "Xuan" are homophones, hence the name. Built in 491 AD, it is a unique temple that combines Buddhism, Taoism and Confucianism. The "Hanging Temple" architecture is very distinctive. It is famous for its steepness as facing the abyss. It is known as the slang term "hanging Temple, half-day high, with three horsetails hanging in the sky". It is famous for its steepness as facing the abyss.
    <br/><br/>
The Hanging Temple is a key cultural relics protection unit in Shanxi Province, and is the "first scenic spot" among the 18 scenic spots in Hengshan. In 2010, he was selected as one of the ten most dangerous buildings in the world by Time Magazine.</p>

    <p className="grey-text">悬空寺，位于山西省大同市浑源县恒山金龙峡西侧翠屏峰峭壁间，原叫“玄空阁”，“玄”取自于中国道教教理，“空”则来源于佛教的教理，后改名为“悬空寺”，是因为整座寺院就像悬挂在悬崖上，在汉语中，“悬”与“玄”同音，因此得名。建成于公元491年，是佛、道、儒三教合一的独特寺庙。“悬空寺”建筑极具特色，以如临深渊的险峻而著称，素有“悬空寺，半天高，三根马尾空中吊”的俚语，以如临深渊的险峻而著称。
<br/><br/>
悬空寺是山西省重点文物保护单位，恒山十八景中“第一胜景”。2010年入选《时代周刊》世界岌岌可危十大建筑。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%82%AC%E7%A9%BA%E5%AF%BA/1132?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/06</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/20.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>The wisdom of the ancients</p>
            <p>I signed up for a one-day-trip today.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title39">
<h4 className="tooltipped title" data-tooltip="恒山">Mount Heng</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/9.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Mount+Heng/@39.6728066,113.7240542,15z/data=!3m1!4b1!4m5!3m4!1s0x35e314eca54c24bd:0x728a6ddd443e0192!8m2!3d39.672791!4d113.732809">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Mount Heng</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9999">Introduction</a>
<div id="modal9999" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Mount Heng - Introduction</h4>
    <p>Hengshan has two concepts in a narrow sense and a broad sense. In the narrow sense, Hengshan is the so-called "Beiyue Hengshan", also known as "Taiheng Mountain". It was called Xuanwu Mountain and Nao Mountain in ancient times. It is high mountain and Xuanyue. It was identified as the "Five Sacred Mountains" in the late Ming and early Qing Dynasty. Located 10 kilometers south of Hunyuan County, Shanxi Province, the main peak Tianfengling is 2016.8 meters above sea level. It is known as "Rentian North Pillar" and "Unbelievably Famous Mountain". In a broad sense, Hengshan Mountain, or Hengshan Mountain Range, is the general term for a series of peaks between the Sanggan River and Hutuo River in the southeast of Datong City, Shanxi Province and the south of Zhangjiakou City, Hebei Province. It is about 80 kilometers wide from north to south. The highest peak is Mantou Mountain at the border of Daixian and Yingxian, with an altitude of 2,426 meters.
    <br/><br/>
Hengshan Mountain lies between the plateau in the northwest of the mountain and the Jizhong Plain. Because of its steep natural mountains and geographical location, it has become a battleground for military experts. In the valleys between mountains, Daomaguan, Zijingguan, Pingxingguan, Yanmenguan, Ningwuguan are dangerous, and they are the key throats of the plateau beyond the Great Wall to the Taiyuan Basin and the Jizhong Plain. Many emperors and famous generals have fought here, and many ancient battlefields such as ancient passes, castles, and beacon towers have been preserved.
<br/><br/>
Since the Ming Dynasty, it was listed as Beiyue. In the early Qing Dynasty, the national sacrifice of Beiyue gradually moved from Quyang, Hebei to Hunyuan Hengshan, and the Wuyue culture was integrated into the Hengshan culture. Hengshan Taoism began in the Western Han Dynasty and flourished in the Northern Wei Dynasty, becoming the holy place of the mainstream Quanzhen School.
<br/><br/>
The Hengshan Mountains are also rich in mineral resources in Shanxi Province, and are the main producing areas of coal and iron in the northeast of Shanxi Province.</p>

    <p className="grey-text">恒山，含狭义和广义两个概念。狭义的恒山，即所谓“北岳恒山”，亦名“太恒山”，古称玄武山、崞山，高是山，玄岳等，明末清初被确定为“五岳”之北岳恒山。位于山西省浑源县城南10公里处，主峰天峰岭海拔2016.8米，号称“人天北柱”、“绝塞名山”。广义的恒山，或称恒山山脉，是山西省大同市东南部、河北省张家口市南部，桑干河、滹沱河之间一系列山峰的总称，大致西南－东北走向延伸，东西长近300公里左右，南北宽80公里左右，最高峰为代县、应县边界处的馒头山，海拔2426米。
<br/><br/>
恒山横亘于山西北部高原与冀中平原之间，因其险峻的自然山势和地理位置的特点，成为兵家必争之地。山间河谷处的倒马关、紫荆关、平型关、雁门关、宁武关虎踞为险，是塞外高原通向太原盆地、冀中平原之咽喉要冲。许多帝王、名将都在此打过仗，古代关隘、城堡、烽火台等众多古代战场遗迹保存了下来。
<br/><br/>
自明代，被列为北岳，清初，北岳国家祭祀也逐渐由河北曲阳移至浑源恒山，五岳文化融入恒山文化中。恒山道教始于西汉，北魏始兴盛，成为主流全真派圣地。
<br/><br/>
恒山山脉也是山西省矿产资源的富集区，是山西省东北部煤、铁等的主产区。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%81%92%E5%B1%B1/395558?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/06</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/21.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Take the cable car to the top of Mount Heng.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title40">
<h4 className="tooltipped title" data-tooltip="云冈石窟">Yungang Grottoes</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/10.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Yungang+Grottoes/@40.1115138,113.1302848,17z/data=!3m1!4b1!4m5!3m4!1s0x35e2cc48520de2e3:0xff93e49966b42707!8m2!3d40.1115097!4d113.1324735">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Yungang Grottoes</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99910">Introduction</a>
<div id="modal99910" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Yungang Grottoes - Introduction</h4>
    <p>The Yungang Grottoes are located at the southern foot of the Wuzhou (Zhou) Mountain and the north bank of the Wuzhou River, about 16 kilometers west of Datong City, Shanxi Province. There are 45 main caves, 252 large and small niches, and more than 51,000 stone statues. It is one of the largest ancient grottoes in China.
    <br/><br/>
Yungang Grottoes was announced by the State Council as one of the first national key cultural relics protection units in 1961. It was included in the UNESCO World Heritage List on December 14, 2001, and was named the first batch of countries by the National Tourism Administration on May 8, 2007. 5A-level tourist attractions.</p>

    <p className="grey-text">云冈石窟位于山西省大同市城西约16公里的武州（周）山南麓、武州川的北岸，石窟依山开凿，东西绵延约1公里。存有主要洞窟45个，大小窟龛252个，石雕造像51000余躯，为中国规模最大的古代石窟群之一。 
<br/><br/>
云冈石窟在1961年被国务院公布为全国首批重点文物保护单位，2001年12月14日被联合国教科文组织列入世界遗产名录，2007年5月8日被国家旅游局评为首批国家5A级旅游景区。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E4%BA%91%E5%86%88%E7%9F%B3%E7%AA%9F/1252?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/06</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/22.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Wei Bei.</p>
            <p>

This is a font that many people do not appreciate.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/23.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Yungang Grottoes-Yungang Giant Buddha</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/24.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Wangfu Zhizunkou Fuju Hot Pot</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title41">
<h4 className="tooltipped title" data-tooltip="九龙壁">Nine Dragon Wall</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/11.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Nine+Dragon+Screen+Ticket+Office/@40.0932401,113.3013573,17z/data=!3m1!4b1!4m5!3m4!1s0x35e2d46238938695:0xce576781633c39aa!8m2!3d40.093236!4d113.303546">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Nine Dragon Wall</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99911">Introduction</a>
<div id="modal99911" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Nine Dragon Wall - Introduction</h4>
    <p>The Nine Dragon Wall of Datong, located in Heyang Street, Pingcheng District, Datong City, Shanxi Province, was built in the 25th year of Hongwu in the Ming Dynasty (1392). It is the front wall of the residence of the thirteenth son of Emperor Zhu Yuanzhang of Ming Dynasty. It has a history of more than 600 years. The wall is 8 meters high, 2.02 meters thick, and 45.5 meters long. There are 9 flying dragons evenly distributed on the wall. There are sun and moon patterns on both sides. The ceiling of the hall-style wall is decorated with embossed lotus flowers and swimming dragons on the ridge. The four corners of the ridge are placed with animals. The wall is made of 426 special multicolored glazed components. The 9 flying dragons are magnificent, and the momentum of flying jumps on the wall.
    <br/>
<br/>
On the Nine Dragon Wall of Datong, the gaps between the dragons are filled with patterns of mountains, rocks and water plants, reflecting and contrasting each other. The wall is covered with glazed tiles, and the top is supported by glazed bucket arches. The bottom of the wall is the Xumizuo, 2.09 meters high, stocky and rich, with 41 sets of two dragons and beads carved on it. The waist is made up of 75 glazed bricks in relief, with cows, horses, sheep, dogs, deer, rabbits and other animal images, which are lively and colorful.</p>

    <p className="grey-text">大同九龙壁，位于山西省大同市平城区和阳街，建于明代洪武二十五年(1392年)，是明太祖朱元璋第十三子朱桂代王府邸前照壁，距今已有600多年的历史。壁高8米，厚2.02米，长45.5米。壁上均匀协调地分布着9条飞龙。两侧为日月图案。庑殿式壁顶，正脊饰凸雕莲花及游龙，四角戗脊置走兽，壁面由426块特制五彩琉璃构件拼砌而成。9条飞龙气势磅礴，飞腾之势跃然壁上。
<br/>
<br/>
大同九龙壁，龙的间隙由山石、水草图案填充，互相映照、烘托。壁顶覆盖琉璃瓦，顶下由琉璃斗拱支撑。壁底为须弥座，高2.09米，敦实富丽，上雕41组二龙戏珠图案。腰部由75块琉璃砖组成浮雕，有牛、马、羊、狗、鹿、兔等多种动物形象，生动活泼，多彩多姿。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%A4%A7%E5%90%8C%E4%B9%9D%E9%BE%99%E5%A3%81/765525?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/07</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/25.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Nine Dragon Wall</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title42">
<h4 className="tooltipped title" data-tooltip="清真大寺">Great Mosque</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/12.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E6%B8%85%E7%9C%9F%E5%A4%A7%E5%AF%BA/@40.0926991,113.2988063,17z/data=!3m1!4b1!4m5!3m4!1s0x35e2d4631c50a565:0xaa74879e5a471ea3!8m2!3d40.092695!4d113.300995">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Great Mosque</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99912">Introduction</a>
<div id="modal99912" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Great Mosque - Introduction</h4>
    <p>The Great Mosque of Datong is one of two well-known ancient mosques in Shanxi. Located in the Ninth Floor Alley, Daxi Street, Datong City, the temple was rebuilt in the 7th year of Emperor Qianlong (1742). "The Monument of the Mosque Built by the Order" is said to have been built in the 2nd year of Tang Zhenguan (628). It has a history of more than 1,200 years. .
    <br/><br/>
It is six hundred and seventy years earlier than the center of worship, gatherings and festivals for Muslims in Beijing and the Dongsi Mosque (also known as Faming Temple) where the Islamic Association of China is located.</p>

    <p className="grey-text">大同清真大寺为山西境内两座知名清真古寺之一。位于大同城内大西街九楼巷，寺内乾隆七年(1742年)重立《敕建清真寺碑》称始建于唐贞观二年(628年)，至今已有一千二百多年的历史。
<br/><br/>
它比北京穆斯林进行礼拜、聚礼和节日活动的中心，中国伊斯兰教协会所在地东四清真寺（又名法明寺）要早六百七十年，或为伪托。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%A4%A7%E5%90%8C%E6%B8%85%E7%9C%9F%E5%A4%A7%E5%AF%BA/8565328?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/07</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/26.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Great Mosque</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title43">
<h4 className="tooltipped title" data-tooltip="华严寺">Huayan Temple</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/13.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Huayan+Temple/@40.0905141,113.3125383,17z/data=!3m1!4b1!4m5!3m4!1s0x35e2d45f1ae0f0a1:0xf6817c1718ad8a84!8m2!3d40.09051!4d113.314727">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Huayan Temple</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99913">Introduction</a>
<div id="modal99913" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Huayan Temple - Introduction</h4>
    <p>Huayan Temple, located in the southwest corner of the ancient city of Datong, was built in the seventh year of Liao Zhongxi (1038 AD) and named after the Buddhist classic "Hua Yan Jing". It also has the nature of the royal ancestral temple of the Liao Kingdom, and its status is prominent. After being destroyed by war, Jin Tianjuan was rebuilt for three years (1140). Huayan Temple sits from west to east. More than 30 single buildings, such as the mountain gate, Puguangming Hall, Daxiong Hall, Bojia Temple, and Huayan Pagoda, are arranged on the two main axes of the north and the south, and the layout is strict.
    <br/>
    <br/>
Huayan Temple, covering an area of 66,000 square meters, is an older and well-preserved Liaojin temple complex in China. It was announced by the State Council in 1961 as the first batch of national key cultural relics protection units. It was approved as a national AAAA-level tourist attraction in 2014.</p>

    <p className="grey-text">华严寺，位于大同古城内西南隅，始建于辽重熙七年（公元1038年），依据佛教经典《华严经》而命名。兼具辽国皇室宗庙性质，地位显赫。后毁于战争，金天眷三年（1140年）重建。华严寺坐西向东，山门、普光明殿、大雄宝殿、薄伽教藏殿、华严宝塔等30余座单体建筑分别排列在南北两条主轴线上，布局严谨。
    <br/>
    <br/>
华严寺，占地面积达66000平方米，是中国现存年代较早、保存较完整的一座辽金寺庙建筑群，1961年被国务院公布为第一批全国重点文物保护单位。2014年被批准为国家AAAA级旅游景区。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%8D%8E%E4%B8%A5%E5%AF%BA/2285867?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>      
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/07</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/27.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Huayan Temple</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/28.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Xijin Road Noodle House</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title44">
<h4 className="tooltipped title" data-tooltip="大明湖">Daming Lake</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/14.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Daming+Lake/@36.6748993,117.0207281,16z/data=!3m1!4b1!4m5!3m4!1s0x35c205d6bfafd47f:0xe9a6983479e96d10!8m2!3d36.6756694!4d117.0257093">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Daming Lake</span>
        </a>

        
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99914">Introduction</a>
<div id="modal99914" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Daming Lake - Introduction</h4>
    <p> Daming Lake (Daming Lake) Jinan city lake in Shandong Province, one of the three historical places in Jinan. Located in the northern part of the old town of Lixia District, Jinan City, Shandong Province, it is formed by the confluence of many springs in Jinan. The lake water flows into Xiaoqing River through Luoshui River. The lake covers an area of 46 hectares with an average water depth of 2 to 3 meters. Daming Lake has beautiful scenery and clear blue water. It is one of the core components of the national 5A-level tourist attraction-the world's first spring scenic area.
    <br/><br/>
Daming Lake has a long history. There are many buildings and natural landscapes that commemorate the achievements and whereabouts of ancients, such as Lixia Pavilion, Tiegong Temple, Xiaocanglang, Arctic Pavilion, Huibo Tower, Nanfeng Temple, Xiayuan Temple, Jiaxuan Temple, etc. Literati of the past dynasties came to mourn and chant. The poets of the past dynasties after the Tang Dynasty have left famous poems.
<br/><br/>
After the liberation, the park was officially opened in 1957, and after several repairs and beautifications, it has become one of the famous tourist attractions in Jinan.</p>

    <p className="grey-text">大明湖（Daming Lake）山东省济南市区湖泊、济南三大历史名胜之一。位于山东省济南市历下区旧城区北部，是由济南众多泉水汇流而成，湖水经泺水河注入小清河。湖水面积46公顷，水深平均2~3米。大明湖景色优美秀丽，湖水水色澄碧，是国家5A级旅游景区——天下第一泉风景区的核心组成部分之一。 
    <br/><br/>
大明湖历史悠久，纪念古人政绩、行踪的建筑以及自然景观很多，诸如历下亭、铁公祠、小沧浪、北极阁、汇波楼、南丰祠、遐园、稼轩祠等，引得历代文人前来凭吊、吟咏。唐代以后的历代诗人，都留下了著名的诗篇。
<br/><br/>
解放后，于1957年正式辟建成公园，几经修缮美化，成为济南市著名的游览胜地之一。
    
   </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%A4%A7%E6%98%8E%E6%B9%96/132623?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>   
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/08</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/29.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Flew to Jinan in the afternoon on the 7th and stayed at the Orange Hotel in Quancheng Square.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/30.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>In the morning, have breakfast at Chao Shisan Chaoshan casserole by Daming Lake.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/31.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Chaoran building</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/32.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Daming Lake</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title45">
<h4 className="tooltipped title" data-tooltip="千佛山">Thousand Buddha Mountain</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/15.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Thousand+Buddha+Mountain/@36.6366694,117.0272882,15z/data=!3m1!4b1!4m5!3m4!1s0x35c204558f64e2b7:0xb566fa9d14adff92!8m2!3d36.636653!4d117.036043">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Thousand Buddha Mountain</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99915">Introduction</a>
<div id="modal99915" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Thousand Buddha Mountain - Introduction</h4>
    <p>Thousand Buddha Mountain is located in Lixia District, Jinan City, Shandong Province. It is one of the three major scenic spots in Jinan. During the reign of Emperor Kaihuang of Sui Dynasty (581-600), because of the prevalence of Buddhism, thousands of Buddha statues were carved along the mountain, so it was called Qianfo Mountain.
    <br/>
<br/>
Thousand Buddha Mountain is the remnant of Mount Tai. It is 285 meters above sea level and covers an area of 166.1 hectares. It is 2.5 kilometers away from Jinan city center. It is located in the south of Jinan city center in Shandong Province. It is also known as the three major scenic spots in Jinan along with Baotu Spring and Daming Lake. It is a national AAAA level. Tourist attractions are the ninth batch of national-level scenic spots.</p>

    <p className="grey-text">千佛山位于山东省济南市历下区，是济南三大名胜之一，古称历山，因为古史称舜在历山耕田的缘故，又曾名舜山和舜耕山。隋开皇年间（581年一600年），因佛教盛行，随山势雕刻了数千佛像，故称千佛山。
    <br/>
<br/>
千佛山是泰山的余脉，海拔285米，占地166.1公顷，距济南市中心2.5公里，位于山东省济南市中心南部，与趵突泉、大明湖并称济南三大名胜，是国家AAAA级旅游景区，是第九批国家级风景名胜区。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%8D%83%E4%BD%9B%E5%B1%B1/3838147?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>

<div className="titleContent">
    <h5>2019/06/08</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/33.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Go to top of Thousand Buddha Mountain by cable car.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/34.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>The slide in Thousand Buddha Mountain, if you go up, your neck will be tired, but going down is fun.</p>
        </div>
    </div>




</div>

</div>

<div className="titles" id="title46">
<h4 className="tooltipped title" data-tooltip="宽厚里">Shimao Kuanhouli Jinan</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/16.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E5%AE%BD%E5%8E%9A%E6%89%80%E8%A1%97/@36.661105,116.9726595,17z/data=!3m1!4b1!4m5!3m4!1s0x35c20f7ab5155555:0x83665bfed76931f1!8m2!3d36.6611007!4d116.9748482">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Shimao Kuanhouli Jinan</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99916">Introduction</a>
<div id="modal99916" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Shimao Kuanhouli Jinan - Introduction</h4>
    <p>Kuanhouli (Shimao Kuanhouli Jinan), also known as Jinan Kuanhouli and Shimao Kuanhouli, is located in the core area of Quancheng Road in Jinan City. Kuanhousuo Street in old Jinan is Shimao Kuanhouli Jinan's traditional vocabulary for the continuation of old Jinan architecture and folklore. Create a century-old historic district in Qilu, where the Mao and the street are in dialogue, the river and the city are shared, the river and the city are echoed, the spring and water are integrated, and the history and modernity blend together.</p>

    <p className="grey-text">宽厚里（Shimao Kuanhouli Jinan），又称济南宽厚里、世茂宽厚里，位于济南市泉城路核心地段，老济南的宽厚所街，是世茂股份为延续老济南建筑、民俗的传统语汇，于城市中心打造茂与街对话、河与市共享，河与城呼应、泉与水融合、历史与现代交融的齐鲁大地百年历史街区。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%AE%BD%E5%8E%9A%E9%87%8C/22099702?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/08</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/35.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>In the afternoon, We came to Kuanhouli for a snack, and then returned to the hotel to blow on the air-conditioning because it was too hot.</p>
        </div>
    </div>


</div>

</div>

<div className="titles" id="title47">
<h4 className="tooltipped title" data-tooltip="芙蓉街">FuRong Street</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/17.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Fu+Rong+Jie,+Quan+Cheng+Lu+Shang+Quan,+Lixia+Qu,+Jinan+Shi,+Shandong+Sheng,+China/@36.666961,117.0208381,17z/data=!3m1!4b1!4m5!3m4!1s0x35c205cfc63c36fb:0x544c4266ddd36c02!8m2!3d36.6669567!4d117.0230268">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">FuRong Street</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99917">Introduction</a>
<div id="modal99917" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">FuRong Street - Introduction</h4>
    <p>Furong Street Furong Street is located in Lixia District, Jinan City, Shandong Province. It is an old street and snack street with characteristics of Jinan in the spring city. Furong Street is a north-south pedestrian street, named for the famous spring on the street-Furong Spring.
    <br/><br/>
Furong Street starts at the south entrance of Donghuaqiangzi Street in the north, and ends at Quancheng Road in the south. It is adjacent to Mashi Street to the east, leading to Fengqiao Street, Xiangfeng Alley and Furong Alley, to the west to Yuhuanquan Street, and to the East Street of Provincial Government. The bluestone pavement is 432 meters long and 4.6 meters wide.</p>

    <p className="grey-text">芙蓉街 Furong Street 位于山东省济南市历下区，是一条泉城济南特色的老街以及小吃街。芙蓉街是一条南北走向的步行街，因街上有名泉——芙蓉泉而得名。
<br/><br/>
芙蓉街北起东花墙子街南口，南至泉城路。东邻马市街，通起凤桥街、翔凤巷和芙蓉巷，西邻玉环泉街，通省府东街。青石板路面，全长432米，宽4.6米。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%8A%99%E8%93%89%E8%A1%97/1832751?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/08</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/36.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>At night, the fountain in Quancheng Square.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/37.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Came to Furong Street to continue eating.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title48">
<h4 className="tooltipped title" data-tooltip="黑虎泉">Black Tiger Springs</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/18.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E9%BB%91%E8%99%8E%E6%B3%89/@36.6624513,117.0311013,17z/data=!3m1!4b1!4m5!3m4!1s0x35c205cca8e0ac0f:0xbcdcc0e1fae69c28!8m2!3d36.662447!4d117.03329">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Black Tiger Springs</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99918">Introduction</a>
<div id="modal99918" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Black Tiger Springs - Introduction</h4>
    <p>Black Tiger Springs (Black Tiger Springs) is located on the south bank of the moat of Jiefangge South, Lixia District, Jinan City, Shandong Province, on the Heihuquan East Road, Jinan City.
    <br/><br/>
Heihu Spring is a natural cave with a height of 2 meters, a depth of 3 meters and a width of 1.7 meters. The spring water mainly comes from the southeast of the cave. The cave is built of bluestone, and the cave is hidden under the rock wall. The spring pool is made of stones and is slightly rectangular, about 17 meters wide and 3 meters deep. Three stone tiger heads are juxtaposed on the south wall of the spring pond. The spring water flows through the dark ditch and spews out through 3 stone tiger mouths. The maximum daily water inflow is 41,000 cubic meters, second only to Baotu Spring. There are 14 famous springs such as Pipa, Xizhong and Jiu Nu nearby, forming the Black Tiger Spring Group.
<br/><br/>
Heihuquan is one of Jinan’s "72 Famous Springs" recorded in the "Famous Spring Stele" of the Jin Dynasty, the "Seven-Two Spring Poems" of Yan Bi in the Ming Dynasty and the "Seven-Two Springs" of Hao Zhigong in the Qing Dynasty. The first of "Huquan Springs". It is one of the three spring groups in the world's first spring national AAAAA-level tourist attraction.</p>

    <p className="grey-text">黑虎泉（Black Tiger Springs），位于山东省济南市历下区解放阁南护城河南岸陡崖下，在济南市黑虎泉东路。 
<br/><br/>
黑虎泉为一天然洞穴，高2米，深3米，宽1.7米，泉水主要来自洞穴的东南方向。洞穴由青石垒砌，洞穴隐露在岩壁下。泉池由石块砌成，略呈长方形，宽约17米，深约3米。泉池南壁并列3个石雕虎头。泉水流过暗沟，经3个石虎口喷出。 涌水量最大每日4.1万立方米，仅次于趵突泉。  附近有琵琶，溪中、九女等名泉14处，组成黑虎泉群。 
<br/><br/>
黑虎泉是金代《名泉碑》、明代晏璧《七十二泉诗》和清代郝植恭《七十二泉记》所著录的济南“七十二名泉”之一，居于“黑虎泉泉群”之首。为天下第一泉国家AAAAA级旅游景区三大泉群之一。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E9%BB%91%E8%99%8E%E6%B3%89/477141?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/09</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/38.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Woke up in the morning and took a taxi to Black Tiger Springs. Some people filled buckets in Baishi Spring.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title49">
<h4 className="tooltipped title" data-tooltip="趵突泉">Baotu Spring</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/19.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Baotu+Spring/@36.6610064,117.0009232,14z/data=!4m8!1m2!2m1!1z6La156qB5rOJ!3m4!1s0x35c205c79e68cb75:0xe1a3a6d3cd45906b!8m2!3d36.66119!4d117.015954">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Baotu Spring</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99919">Introduction</a>
<div id="modal99919" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Baotu Spring - Introduction</h4>
    <p>Baotu Spring, one of the three major scenic spots in Jinan, is located in Lixia District, Jinan City, Shandong Province. It faces Quancheng Square to the east and Wulongtan to the north. It covers an area of ​​158 acres and ranks first among the 72 famous springs in Jinan. During the Qianlong emperor's southern tour, the Baotu Spring water was mellow and sweet, and Baotu Spring was once designated as the "First Spring in the World". It is also the famous spring of Jinan first seen in ancient documents.
    <br/><br/>
Baotu Spring is located in front of Luoyuan Hall in Baotu Spring Park. In the twentieth year of the Republic of China (1931), the surrounding stone banks were built. After several changes, a rectangular spring pool was formed, 30 meters long, 18 meters wide and 2.2 meters deep. It is bordered by Luoyuan Hall in the north, Guanlan Pavilion in the west, Laihe Bridge in the east, and a long corridor in the south. Spring water gushes from underground limestone caves, and 70,000 cubic meters of spring water gushes out every day. There are three water outlets for spring water, and the maximum water inflow is 162,000 meters per day. Baotu spring water is constant at around 18°C ​​throughout the year. The places of interest around Baotu Spring include Luoyuan Hall, Guanlan Pavilion, Shangzhi Hall, Li Qingzhao Memorial Hall, and Li Kuchan Memorial Hall.
<br/><br/>
Baotu Spring, Thousand Buddha Mountain and Daming Lake are also known as the three major scenic spots in Jinan. In 2013, the "First Spring Scenic Spot in the World" represented by Baotu Spring became a national AAAAA-level tourist attraction. On the afternoon of September 5, 2016, Baotu Springs Provincial Geopark was inaugurated and opened.</p>

    <p className="grey-text">趵突泉（Baotu Spring），济南三大名胜之一，位于山东省济南市历下区，东临泉城广场，北望五龙潭，面积达158亩，位居济南七十二名泉之冠。乾隆皇帝南巡时因趵突泉水泡茶味醇甘美，曾册封趵突泉为“天下第一泉”。也是最早见于古代文献的济南名泉。 
<br/><br/>
趵突泉泉眼位于趵突泉公园内的泺源堂前。民国二十年（1931年）四周用石砌岸。几经变化，形成长方形泉池，长30米，宽18米，深2.2米。北临泺源堂，西傍观澜亭，东架来鹤桥，南有长廊围合。泉水从地下石灰岩溶洞中涌出，每天涌出7万立方米泉水，泉水有三个出水口，最大涌水量为16.2万米/天。趵突泉水一年四季恒定在18℃左右。趵突泉周边的名胜古迹有泺源堂、观澜亭、尚志堂、李清照纪念堂、李苦禅纪念馆等景点。
<br/><br/>
趵突泉与千佛山、大明湖并称为济南三大名胜。2013年，以趵突泉为代表的“天下第一泉景区”成为国家AAAAA级旅游景区。2016年9月5日下午，趵突泉泉群省级地质公园揭牌开园。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%B6%B5%E7%AA%81%E6%B3%89/162170?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/09</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/39.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Eating hot pot in Hang Lung Plaza at noon.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/40.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Baotu Spring Scenic Area</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/41.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p></p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/42.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Li Qingzhao Memorial Hall</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/43.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>In the evening, take the high-speed rail to Weifang.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title50">
<h4 className="tooltipped title" data-tooltip="风筝广场">Memorial of World Kite Capital</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/20.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Memorial+of+World+Kite+Capital/@36.7130936,119.0884907,14z/data=!4m8!1m2!2m1!1z5r2N5Z2K6aOO562d5bm_5Zy6!3m4!1s0x359519de16da5885:0x52475bf7f8916ab!8m2!3d36.705779!4d119.114859">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Memorial of World Kite Capital</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99920">Introduction</a>
<div id="modal99920" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Memorial of World Kite Capital - Introduction</h4>
    <p>Weifang Kite Plaza is located in the center of Weifang. It is a civic activity plaza that integrates civil air defense fortifications, commerce and shopping, leisure and entertainment, and highlights the "environmental protection", "humanistic characteristics" and "kite cultural characteristics". The total area is about 9 hectares, of which the upper square area of the first phase is about 48,000 square meters, and the lower riverside landscape area is about 9,500 square meters, totaling 57,500 square meters. The above-ground landscape of the square will be built with ten major landscapes including Mascot Avenue, Central Square, Riverside Scenic Area, Amphitheatre and Wharf, China World Trade Center Ladder Plaza, Siping Road Exit Plaza, Kite Museum Entrance Plaza, Children's Playground, Botanical Park, and Tree Array.</p>

    <p className="grey-text">潍坊风筝广场位于潍坊市中心，是一个集人防工事、商贸购物、休闲娱乐等多功能于一体，凸现“环保特色”、“人文特色”和“风筝文化特色”的市民活动广场。总占地面积约9公顷，其中一期上部广场面积约48000平方米，下部滨河景观区面积约9500平方米，计57500平方米。广场地上景观将建设吉祥物大道、中心广场、滨河景观区、露天剧场与码头，国贸阶梯广场、四平路出口广场、风筝博物馆入口广场、儿童游戏场，植物公园、树阵等十大景观。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E9%A3%8E%E7%AD%9D%E5%B9%BF%E5%9C%BA/5783462?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/09</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/44.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Eat Hele.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/45.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>There were many people walking their dogs in the square.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title51">
<h4 className="tooltipped title" data-tooltip="吃喝玩乐">Fun</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/21.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Taihua+New+Plaza/@36.7131599,119.0884907,14z/data=!4m8!1m2!2m1!1z5rOw5Y2O5paw5aSp5Zyw576O6aOf6KGX!3m4!1s0x359519dce7159d69:0x3554596513157328!8m2!3d36.711015!4d119.112436">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Taihua Xintiandi</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


{/* <a className="btn-flat modal-trigger right info " href="#modal99921">Introduction</a>
<div id="modal99921" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">吃喝玩乐 - Introduction</h4>
    <p>英吉利湾位于加拿大不列颠哥伦比亚省的温哥华市，在市区半岛和福溪附近。 它由Burrard入口的南侧组成，从西南的Point Grey延伸到东北的Prospect Point。
    <br/>
    <br/>
    日落海滩位于西区，靠近伯拉德街大桥和温哥华国际旅馆。 温哥华水上运动中心位于日落海滩的东端，紧邻伯拉德街大桥的北端。 在温暖的月份，海滩上有救生员值班。 公共洗手间和特许摊位就在附近。 自行车道，步行道和直排轮滑道蜿蜒蜿蜒在海滩区上方，一个方向通往斯坦利公园，另一个方向通往耶鲁镇。 温哥华规模的游泳馆温哥华水上运动中心的南部有一个无牵引绳的区域。 这是观看温哥华烟花的热门地点。
    </p>

    <p className="grey-text">English Bay is located in Vancouver, British Columbia, Canada, west of the downtown peninsula and False Creek. It consists of the south side of the Burrard Inlet, extending from Point Grey in the southwest to Prospect Point in the northeast.
    <br/>
    <br/>
    Sunset Beach is situated in the West End near the Burrard Street Bridge and Vancouver International Hostel. The Vancouver Aquatic Centre lies at the East end of Sunset beach right next to the North end of Burrard Street Bridge. The beach has lifeguards on duty in the warm months. Public washrooms and concession stands are nearby. Biking, walking and inline skating paths wind above the beach area, leading to Stanley Park in one direction and Yaletown in the other. There is an off leash area to the south of the Vancouver Aquatic Centre, an Olympic size natatorium. It is a popular location for watching Vancouver fireworks.</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/English_Bay,_Vancouver">
        <span className="blue-text">[Source From...]</span>
    </a>   
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div> */}

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/10</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/46.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Eat Huoshao.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/47.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Fly a kite.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/48.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Have a barbecue for dinner.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/49.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>After dinner, go to Taihua Xintiandi Food Street to buy snacks.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title52">
<h4 className="tooltipped title" data-tooltip="赶集">Go to the market</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/22.png" alt="" className="responsive-img"></img>
        {/* <br></br>
        <a href="">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">赶集</span>
        </a> */}

        
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


{/* <a className="btn-flat modal-trigger right info " href="#modal99922">Introduction</a>
<div id="modal99922" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">赶集 - Introduction</h4>
    <p>布勒桥是加拿大卑诗省温哥华市内一条桁架桥，横越福溪的西端，连接温哥华市中心及基斯兰奴区。大桥现时有5条行车线，贯通两岸的布勒街，并设于行车线两旁设有行人及自行车通道。大桥的装饰艺术风格令其成为温市的主要地标之一。
        <br/><br/>
    格兰维尔街大桥不列颠哥伦比亚省温哥华的8车道大桥。大桥高27.4米，横跨福溪和格兰维尔岛。99号公路通行其上。此处原来的大桥于1889年建成。这是一座732米长的低矮木栈桥。靠近北端的通航孔是一个木桁架回转开启孔，两端由钢索斜拉挂在中央木塔上。大桥的主要设计由加拿大和平铁路公司完成，耗资一点六万美元。大桥于1891年改造加宽，在两侧设置了电车轨道，而在回转孔范围内，两侧的轨道交汇到了一起。第二座桥于1909年建成。这是一座更长的钢桥，通航孔是一个下承式桁架回转开启孔。
    </p>

    <p className="grey-text">Burrard Street Bridge is a truss bridge in Vancouver, British Columbia, Canada. It crosses the western end of False Creek and connects downtown Vancouver and Kitsilano District. The bridge currently has 5 traffic lanes running through Buller Street on both sides of the strait. Pedestrian and bicycle lanes are provided on both sides of the traffic lane. The Art Deco style of the bridge makes it one of the main landmarks of Vancouver.
    <br/><br/>
    Granville Bridge An 8-lane bridge in Vancouver, British Columbia. The bridge is 27.4 meters high and spans False Creek and Granville Island. Highway 99 runs through it. The original bridge here was completed in 1889. This is a low wooden trestle bridge with a length of 732 meters. The navigation hole near the north end is a wooden truss swing opening hole, and both ends are hung on the central wooden tower by steel cables. The main design of the bridge was completed by the Canadian Peace Railway Company at a cost of 16,000 US dollars. The bridge was remodeled and widened in 1891. Tram tracks were set on both sides, and within the revolving hole, the tracks on both sides merged together. The second bridge was completed in 1909. This is a longer steel bridge, and the navigation hole is a through-type truss turning opening hole.
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%B8%83%E5%8B%92%E6%A1%A5/14484441?fr=aladdin">
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div> */}

</div>
    </div>
</div>


<div className="titleContent">
<h5>2019/06/11</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/50.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Big dumplings.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title53">
<h4 className="tooltipped title" data-tooltip="风筝博物馆">World Kite Museum of Weifang</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/23.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Weifang+World+Kite+Museum/@36.7038033,119.1128323,17z/data=!3m1!4b1!4m5!3m4!1s0x359519dfce31bcbd:0x25cf44d280e85859!8m2!3d36.703799!4d119.115021">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">World Kite Museum of Weifang</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99923">Introduction</a>
<div id="modal99923" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">World Kite Museum of Weifang - Introduction</h4>
    <p>The World Kite Museum of Weifang (World Kite Museum of Weifang) is located at No. 66 Administrative Street, Kuiwen District, Weifang City, Shandong Province. It was officially completed on April 1, 1989 and opened to the public. In November 2003, it was under the management of Weifang Tourism Bureau. The first professional kite art museum.
    <br/>
<br/>
The Weifang World Kite Museum covers a total area of 13,000 square meters, with a total construction area of 8,100 square meters. There are 12 large and small exhibition halls in the museum. There are more than 1,300 kite exhibits in the collection, showing various Chinese and foreign kites from the 5th century B. The style kite comprehensively shows the historical culture, modern culture, international culture and extended culture of the kite.
<br/>
<br/>
Weifang World Kite Museum is a national AAA tourist scenic spot. In January 2020, Weifang World Kite Museum was selected as "Shandong Province's Six Goods"</p>

    <p className="grey-text">潍坊世界风筝博物馆（World Kite Museum of Weifang）位于山东省潍坊市奎文区行政街66号，于1989年4月1日正式竣工并对外开放，2003年11月归属潍坊市旅游局管理，为全国第一座风筝艺术类专业博物馆。
    <br/>
<br/>
潍坊世界风筝博物馆总占地面积1.3万平方米，总建筑面积8100平方米，馆内共有大小展厅12个，馆藏风筝展品1300余件，展现了从公元前5世纪“鲁班风筝”至今的中外各式风筝，全面展示了风筝的历史文化、现代文化、国际文化及延伸文化。
<br/>
<br/>
潍坊世界风筝博物馆为国家AAA级旅游风景区。2020年1月，潍坊世界风筝博物馆入选“山东省'六好'齐赏好景景区”
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%BD%8D%E5%9D%8A%E4%B8%96%E7%95%8C%E9%A3%8E%E7%AD%9D%E5%8D%9A%E7%89%A9%E9%A6%86/9009221?fromtitle=%E9%A3%8E%E7%AD%9D%E5%8D%9A%E7%89%A9%E9%A6%86&fromid=1431244&fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>

</div>

<div className="titleContent">
    <h5>2019/06/11</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/51.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>World Kite Museum of Weifang</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/52.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>In the evening, We ordered food, barbecue, beer takeaway in hotel.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title54">
<h4 className="tooltipped title" data-tooltip="十笏园">Shihuyuan Garden</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/24.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Weifang+Shihu+Garden+Museum/@36.7159973,119.0967512,15z/data=!4m8!1m2!2m1!1z5Y2B56yP5Zut!3m4!1s0x359519d004ac4c05:0xa77b1b399af89b8a!8m2!3d36.715327!4d119.105444">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Shihuyuan Garden</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99924">Introduction</a>
<div id="modal99924" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Shihuyuan Garden - Introduction</h4>
    <p>Shihuyuan Garden (Shihuyuan Garden), also known as Dingjia Garden, is located at No. 49 Hujiapaifang Street, Weicheng District, Weifang City, Shandong Province. ", hence the name "Ten Wat Garden".
    <br/><br/>
The Shihu Garden is rectangular in plan and consists of three ancient architectural axes: the middle, west and east. The central axis building and its courtyard are the main part of the garden. The main building in the garden is the Yanxiang Building, which was built in the Ming Dynasty, with three bays and two floors. On the wall of the building, there are more than 90 original inscriptions of calligraphers and painters such as Zheng Banqiao and Jinnong. It is one of the small and exquisite gardens in the north of China.
<br/><br/>
In 1988, Shihu Garden was announced as the third batch of national key cultural relics protection units by the State Council.</p>

    <p className="grey-text">十笏园（Shihuyuan Garden），又名丁家花园，位于山东省潍坊市潍城区胡家牌坊街49号，面积约2000平方米，因占地非常少，时人喻之为“十个笏板”，故得名“十笏园” 。
    <br/><br/>
十笏园平面呈长方形，由中、西、东三条古建筑轴线组成，中轴线建筑及其院落为园之主体部分，园内的主要建筑砚香楼，始建于明代，三开间，二层楼，墙壁上嵌有郑板桥、金农等书画家的真迹碑刻90余方，是中国北方地区具有江南园林小巧玲珑特色的园林之一 。
<br/><br/>
1988年，十笏园被国务院公布为第三批全国重点文物保护单位。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E5%8D%81%E7%AC%8F%E5%9B%AD/779498?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/12</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/53.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Eat Chaotianguo.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/54.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Shihuyuan Garden</p>
        </div>
    </div>





</div>

</div>

<div className="titles" id="title55">
<h4 className="tooltipped title" data-tooltip="关帝庙">Guandi Temple</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/25.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Guandi+Temple,+Qingzhou,+Weifang,+Shandong,+China/@36.5973554,118.6971152,15z/data=!3m1!4b1!4m5!3m4!1s0x35954b1186135e27:0xc87baa02e0b4192a!8m2!3d36.597339!4d118.70587">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Guandi Temple</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


{/* <a className="btn-flat modal-trigger right info " href="#modal99925">Introduction</a>
<div id="modal99925" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">关帝庙 - Introduction</h4>
    <p>关帝庙位于温哥华Gastown街区的Cambie和Water街的转角处。 这个钟的来历很有趣。当年的水街采用蒸汽集中供热，一条条供热管将中心锅炉产生的热蒸汽输送到各家各户。为了散去多余的蒸汽，人们不得不在街上开了3个散蒸汽口，可其中一个恰好位于最繁华的水街路口，既不雅观，也不方便。1854年，一个叫桑德斯的聪明人巧妙地利用这个散蒸汽口的废蒸汽，建成了这座当时世界上独一无二的关帝庙。</p>

    <p className="grey-text">The Steam Clock is located at the corner of Cambie and Water Streets in the Gastown neighborhood of Vancouver. The origin of this clock is very interesting. At that time, the water street used steam central heating, and the heating pipes transported the hot steam produced by the central boiler to each household. In order to dissipate the excess steam, people had to open three steam outlets on the street, but one of them happened to be located at the most prosperous Shuijie intersection, which was both unsightly and inconvenient. In 1854, a clever man named Sanders cleverly used the waste steam from the steam outlet to build this unique steam clock in the world at that time.</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%92%B8%E6%B1%BD%E9%92%9F/2987407?fr=aladdin">
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div> */}

</div>
    </div>
</div>


<div className="titleContent">
<h5>2019/06/12</h5>
<div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/55.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Arrive in Penglai by car in the afternoon and order takeaway dinner at the hotel.</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title56">
<h4 className="tooltipped title" data-tooltip="蓬莱阁">Penglai Pavilion</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/26.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Maple+Tree+Square,+Vancouver,+BC/@49.2834016,-123.1061831,17z/data=!3m1!4b1!4m5!3m4!1s0x548671774ec789ed:0x8f0ba62a2d67e218!8m2!3d49.2833664!4d-123.104129">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Penglai Pavilion</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99926">Introduction</a>
<div id="modal99926" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Penglai Pavilion - Introduction</h4>
    <p> Penglai Pavilion, located in Penglai District, Yantai City, Shandong Province, is an ancient architectural complex. The main building of Penglai Pavilion was built in the sixth year of Jiayou in the Song Dynasty (1061). It is known as the "Wonderland on Earth", and its legend of "Eight Immortals Crossing the Sea" and "mirage of the sea" are well-known at home and abroad.
    <br/><br/>
Penglai Pavilion has gone through the vicissitudes of wind and rain, and now it has developed into an ancient building complex as its central axis, Penglai Water City and Tian Hengshan as its two wings, four cultures (fairy culture, Jingwu culture, port culture, ocean culture) as the foundation, mountain (Danya Mountain) , Sea (Yellow and Bohai Sea), City (Penglai Water City), Pavilion (Penglai Pavilion) are the layouts, and more than 20 scenic spots such as Dengzhou Museum, Ancient Ship Museum, Tian Hengshan, Hehai Pavilion and the boundary coordinates of the Yellow and Bohai Sea are dotted. It is a scenic spot and leisure resort integrating natural scenery, historical sites, cultural landscapes, leisure and entertainment.</p>

    <p className="grey-text">蓬莱阁，位于山东省烟台市蓬莱区，是一处古建群。蓬莱阁的主体建筑建于宋朝嘉祐六年（1061年），素以“人间仙境”著称于世，其“八仙过海”传说和“海市蜃楼”奇观享誉海内外。 
<br/><br/>
蓬莱阁历经风雨沧桑，如今已发展成以古建筑群为中轴，蓬莱水城和田横山为两翼，四种文化（神仙文化、精武文化、港口文化、海洋文化）为底蕴，山（丹崖山） 、海（黄渤二海）、城（蓬莱水城）、阁（蓬莱阁）为格局，登州博物馆、古船博物馆、田横山、合海亭及黄渤海分界坐标等20余处景点为点缀，融自然风光、历史名胜、人文景观、休闲娱乐于一体的风景名胜区和休闲度假胜地。
    
   </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%93%AC%E8%8E%B1%E9%98%81/63337?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/13</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/56.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Porridge</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/57.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Dengzhou Ancient Ship Museum</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/58.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Penglai Pavilion Scenic Area - Tian Heng Mountain</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title57">
<h4 className="tooltipped title" data-tooltip="海洋极地世界">Ocean Aquarium of Penglai</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/27.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Ocean+Aquarium+of+Penglai/@37.8256692,120.7445743,17z/data=!3m1!4b1!4m5!3m4!1s0x3591b0305e279669:0xab5d8e2f62b3ec1c!8m2!3d37.825665!4d120.746763">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Ocean Aquarium of Penglai</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99927">Introduction</a>
<div id="modal99927" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Ocean Aquarium of Penglai - Introduction</h4>
    <p>              Penglai Ocean Polar World is located at the foot of Danya Mountain in Penglai, adjacent to the famous Penglai Pavilion. It was built by Penglai Haifeng Industrial Co., Ltd. with an investment of 460 million. It is a collection of ornamental, entertaining, interesting, thrilling and reflective marine culture A comprehensive exhibition hall integrating science and technology. The entire exhibition area covers an area of 51,800 square meters, and is divided into 14 exhibition halls, including tropical rainforest pavilion, polar pavilion, shark pavilion, dolphin and sea lion performance hall, turtle pavilion, seal pavilion, underwater theater, four-dimensional dynamic cinema, multimedia exhibition hall From the equatorial tropical rain forest to the polar regions of the Arctic Ocean, there are more than a thousand species of rare marine life around the world.</p>

    <p className="grey-text">蓬莱海洋极地世界坐落于蓬莱丹崖山下，与著名的蓬莱阁毗邻，由蓬莱海锋实业有限公司投资4.6亿建设，是一个集观赏性、娱乐性、趣味性、惊险刺激和反映海洋文化、海洋科技为一体的综合性展馆。整个展区面积5.18万平方米，分为热带雨林馆、极地馆、鲨鱼馆、海豚海狮表演馆、海龟馆、海豹馆、水下剧场、四维动感影院、多媒体展览馆等14个展馆，汇集了从赤道热带雨林到北冰洋极地世界各地珍稀海洋生物千余种。
</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E8%93%AC%E8%8E%B1%E6%B5%B7%E6%B4%8B%E6%9E%81%E5%9C%B0%E4%B8%96%E7%95%8C/10095766?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/13</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/59.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Ocean Aquarium of Penglai is next to Penglai Pavilion, walk to it.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/60.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Mermaid Performance.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/61.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Dolphin and sea lion show.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/62.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Dinner</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title58">
<h4 className="tooltipped title" data-tooltip="九丈崖">Jiuzhangya Park</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/28.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E9%95%BF%E5%B2%9B%E4%B9%9D%E4%B8%88%E5%B4%96/@37.921417,120.7015651,13z/data=!4m11!1m2!2m1!1z5Lmd5LiI5bSW!3m7!1s0x3591b70d1fd19f23:0xb0e8c3c685cfe7e7!5m2!4m1!1i2!8m2!3d37.921417!4d120.736584">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Jiuzhangya Park</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99928">Introduction</a>
<div id="modal99928" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Jiuzhangya Park - Introduction</h4>
    <p>Jiuzhangya is named because of the high and steep cliffs. The existing Jiuzhangya Park covers an area of 3,000 square meters. There are: one, Pearl Tunnel; two bays, Pearl Bay and Ouchi Bay; Three Cliffs , Namely Stone Pagoda Cliff, Jiuzhang Cliff, Longpan Cliff; four platforms, namely observation deck, fishing platform, dressing table, and Dianjiang platform; five holes, namely Sanyuan Cave, Luzu Cave, Xiangu Cave, Shrimp Cave, Qixian Cave ; Six reefs, namely Incense Burner Reef, Pearl Reef, Threshold Reef, Warship Reef, Seal Reef, Wolong Reef; Seven Stones, namely nine-fold stone, crystal stone, longevity stone, ghost stone, chessboard stone, random thought stone, triple jumping stone And other major attractions.</p>

    <p className="grey-text">由于崖壁的高且险峻而得名的九丈崖，现建九丈崖公园总占地面积3000平方米，有：一道，即珍珠隧道；二湾，即珍珠湾、鸥翅湾；三崖，即石塔崖、九丈崖、龙盘崖；四台，即观景台、垂钓台、梳妆台、点将台；五洞，即三元洞、吕祖洞、仙姑洞、虾精洞、七仙洞；六礁，即香炉礁、珍珠礁、门槛礁、军舰礁、海狗礁、卧龙礁；七石，即九叠石、水晶石、长寿石、鬼爷石、棋盘石、随想石、三跳石等主要景点。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E4%B9%9D%E4%B8%88%E5%B4%96%E9%A3%8E%E6%99%AF%E5%8C%BA/7295153?fromtitle=%E4%B9%9D%E4%B8%88%E5%B4%96&fromid=6575719&fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/14</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/63.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Breakfast - takeaway ordered at the hotel.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/64.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>dock</p>
            <p>Go to Changdao by ship</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/65.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Jiuzhangya Park</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/66.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Jiuzhangya Park</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/67.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Jiuzhangya Park</p>
        </div>
    </div>



</div>

</div>

<div className="titles" id="title59">
<h4 className="tooltipped title" data-tooltip="月牙湾">Yueyawan Park</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/29.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Yueyawan+Park/@37.9859752,120.7142453,17z/data=!3m1!4b1!4m5!3m4!1s0x3591c8093e4f1c9d:0x3886571a6e505461!8m2!3d37.985971!4d120.716434">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Yueyawan Park</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99929">Introduction</a>
<div id="modal99929" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Yueyawan Park - Introduction</h4>
    <p>Crescent Bay, also known as Half Moon Bay, is located at the northernmost tip of North Changshan Island in Changdao County. It naturally forms the Crescent Long Beach with a length of about 2,000 meters. It is named after the bay is shaped like a half moon. It is backed by green mountains and green fields, surrounded by blue seas and clear waves, and a long beach of silver and white balls, embedded in the green mountains and blue water, is like a crescent moon in the deep night sky.</p>

    <p className="grey-text">月牙湾又称半月湾，坐落于长岛县北长山岛最北端，自然形成长约2000米的月牙长滩，因湾形似半月而得名。它背依青山绿野，环抱碧海清波，一袭银白球石的遥遥长滩，镶嵌在青山碧水之间，犹如深邃夜空中的一弯新月。
</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E6%9C%88%E7%89%99%E6%B9%BE/79523?fr=aladdin">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>     
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
    <h5>2016/07/01</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img12/5.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>随后我来到英吉利湾和日落海滩。温哥华的气候非常温暖舒适，人们三三两两悠闲自在地坐在海滩边。</p>
            <p>我沿着海岸线从北走到南，吹着海风，十分惬意。</p>
        </div>
    </div>



</div> */}

</div>

<div className="titles" id="title60">
<h4 className="title" >Xianjingyuan</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img23/30.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/%E9%95%BF%E5%B2%9B%E9%BB%84%E6%B8%A4%E6%B5%B7%E5%88%86%E7%95%8C%E7%BA%BF/@37.9269402,120.7427833,17z/data=!3m1!4b1!4m5!3m4!1s0x3591b7a792c18647:0x86a110efe5a3eaad!8m2!3d37.926936!4d120.744972">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Yellow Sea and Bohai Sea boundary</span>
        </a>

        
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99930">Introduction</a>
<div id="modal99930" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Yellow Sea and Bohai Sea boundary - Introduction</h4>
    <p>This is the magnificent scene of the natural boundary between the Yellow Sea and the Bohai Sea in Laotie Mountain. Lao Tie Shan Jiao, located at the tip of the Liaodong Peninsula, extends between the Yellow Sea and the Bohai Sea, forming the natural boundary between the Yellow Sea and the Bohai Sea. The color of the sea water can be described as “clearly distinct”. Part of the Yellow Sea in the east is dark blue, while the Bohai Sea in the west is turbid and slightly yellow. This is because of the natural phenomenon formed by the seabed trench.</p>

    <p className="grey-text">“老铁山头入海深，黄海渤海自此分。西去急流如云涌，南来薄雾应风生”。此即为地处老铁山的黄海和渤海自然分界的壮观景象。 老铁山角，位于辽东半岛的尖端，延伸黄海和渤海之中，形成黄海和渤海的自然分界，在海水的颜色上可谓“泾渭分明”。东部黄海部分水是深蓝色，而西部渤海水却显得浑浊，略呈微黄色。这是因为所处海底地沟所形成的自然现象。
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://baike.baidu.com/item/%E9%BB%84%E6%B8%A4%E6%B5%B7%E5%88%86%E7%95%8C%E7%BA%BF/8691230?fr=aladdin">
        <span className="blue-text">[Source From...]</span>
    </a>   
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2019/06/14</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/68.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Yellow Sea and Bohai Sea boundary</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/69.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Return to Penglai.</p>
        </div>
    </div>

    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img24/70.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Have crayfish hot pot for dinner.</p>
            <p>See you next time, Shanxi, Shandong.</p>
        </div>
    </div>



</div>

</div>


    <h4 className="title"> </h4>

    {/* <div className="Comment">
    
        <div className="row">   
        <div className="col s1 m1 l1">
            <a className="btn btn-floating black lighten-1 ">YX</a>
        </div>
        <div className="col s11 m11 l11 commentContent">
            <form action="">
                <div className="input-field">
                    <textarea id="message" className="materialize-textarea"></textarea>
                    <label htmlFor="message">发表评论</label>
                </div>
            </form>
        </div>
        </div>

      

    </div> */}



</div>
</div>
        
            
            
            <footer className="page-footer black darken-3">
                <div className="container">
                <div className="row">

                    <div className="flex text-xs-center col l1 m2 s12">
                        {/* <img salt="" className="responsive-img"></img> */}
                        <p className="center">Y.X.</p>
                    </div>

                    <div className="col l5 offset-l1 m5 s12 hide-on-small-only">
                    <h5>Who is Y.X.?</h5>
                    <p>Y.X. graduated from uOttawa in 2020. She studied computer science and mathematics. She enjoys programming, travelling & playing instruments.</p>
                    </div>
              

                    <div className="col l4 offset-l1 m5 s12">
                    {/* <h5 className="white-text">Connect</h5> */}
                    <div className="text-xs-center mx my social-icons">
                    <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/crys___7" className=" btn-floating btn-small transparent" >
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UClv5NmxBvWIjid8crocDvZQ" className=" btn-floating btn-small transparent">
                        <i className="fab fa-youtube"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=100006981077508" className=" btn-floating btn-small transparent">
                        <i className="fab fa-facebook"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/YueqingXie" className=" btn-floating btn-small transparent">
                        <i className="fab fa-twitter"></i>
                    </a>
                    </div>
                    </div>
                </div>
                </div>
                <div className="footer-copyright grey darken-4">
                <div className="container copyright center-align">Copyright &copy; 2020 Y.X.</div>
                </div>
            </footer>
  
            </section>
        )
    }
}





export default travelNoteShanxiShandong